import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  DatePicker,
  Select,
  format_date,
  saveAs,
  GET,
  GET_FILE,
  POST,
  PUT,
  DELETE,
  Modal,
  t,
  can,
} from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";
import { getProfile } from "../../utils/localStorage.js";
import {
  DEALS,
  PROPERTY_STATUS,
  parkingTypes,
  contractUnitMeta,
  statusMeta,
  amenityMeta,
  tagMeta,
  directionMeta,
  nearbyMeta,
} from "../../components/asset_option.js";
import { channelGlyph, ageLevel, coverageColor } from "../../components/marketing_option.js";
import "../../assets/css/property.css";
// ปฏิทินของหน้านี้ใช้สไตล์ชุดเดียวกับปฏิทินนัดหมาย (crm-cal / crm-cell / crm-monthbar)
// ปรับสีหรือเอฟเฟกต์ที่ crm.css ที่เดียว ทั้งสองเมนูจะขยับตามกันเสมอ
import "../../assets/css/crm.css";
import "../../assets/css/marketing.css";

/* ============================================================================
 * การตลาด › คิวงานโพสต์  (/ad/marketing)
 *
 * หน้านี้ตอบคำถามเดียว : "วันนี้ต้องเอาทรัพย์ตัวไหนไปโพสต์ที่ไหนบ้าง"
 * จึงจัดลำดับการอ่านไว้เป็น 3 ชั้น
 *   1) การ์ดสรุป  — ภาพรวมว่าค้างเยอะแค่ไหน กดการ์ดแล้วกรองรายการตามนั้นได้ทันที
 *   2) การ์ดกรอง  — ตัวกรองทั้งหมดอยู่ในการ์ดเดียว เห็นพร้อมกันหมด ไม่มีอะไรพับซ่อนไว้
 *   3) ตาราง     — เนื้องานจริง แถวละ 1 ทรัพย์ เห็นครบว่าโพสต์ล่าสุดเมื่อไร
 *                  ลงช่องทางไหนไปแล้ว ยังขาดกี่ช่อง และใครรับผิดชอบ
 *
 * รายการตั้งต้นมาจากตาราง assets (ทรัพย์ที่ยังว่างและไม่ได้เก็บเข้ากรุ)
 * ส่วนสถานะการโพสต์มาจากตาราง asset_marketing_posts ที่ประกบมาให้แล้วจาก API
 * การกรอง เรียงลำดับ และแบ่งหน้า ทำที่ฝั่ง API ทั้งหมดเหมือนหน้ารวมทรัพย์
 *
 * ต่อกับ API แล้ว :
 *   GET    admin/marketing                (Get — ตัวกรองทั้งหมดส่งไปเป็น query)
 *   GET    admin/marketing/summary        (การ์ดสรุปด้านบน)
 *   GET    admin/marketing/:uid/posts     (ประวัติการโพสต์ของทรัพย์ 1 รายการ)
 *   POST   admin/marketing/:uid/posts     (บันทึกการโพสต์ของทรัพย์รายการเดียว)
 *   POST   admin/marketing/posts          (บันทึกให้ทรัพย์ที่ติ๊กเลือกไว้ทั้งหมดพร้อมกัน)
 *   DELETE admin/marketing/posts/:uid     (ลบบันทึกการโพสต์ที่ลงผิด)
 *   GET    admin/marketing-channels       (ช่องทางที่เปิดใช้งาน)
 *   GET    admin/asset-categories · admin/users · admin/assets/zones (ตัวเลือกตัวกรอง)
 * ========================================================================== */

const PAGE_SIZE = 10;

/* จำนวนทรัพย์สูงสุดที่บันทึกพร้อมกันได้ใน 1 ครั้ง — ต้องไม่เกิน MAX_BULK_ASSETS ของ API
   (ติ๊กสะสมข้ามหน้าได้ ถ้าไม่มีเพดานก็เผลอกดทับทั้งฐานข้อมูลได้ในคลิกเดียว) */
const MAX_BULK = 200;

/* --------------------------------------------------------------- design tokens */
/* สถานะทรัพย์ใช้ชุดกลางจาก asset_option.js (statusMeta / PROPERTY_STATUS) */

/* การ์ดสรุปด้านบน — key ตรงกับค่าที่ API คืนมาใน summary และ state ที่ส่งกลับไปกรอง
   ใบแรกเป็นตัวตั้ง (ไม่ได้กรองอะไร) อีก 4 ใบเป็นตัวกรองที่กดสลับได้ */
const KPI_CARDS = [
  { key: "total", state: "", label: "mk_kpi_total", icon: "", color: "#047857", tint: "#d1fae5", share: false },
  { key: "not_today", state: "not_today", label: "mk_kpi_not_today", icon: "", color: "#b45309", tint: "#fef3c7" },
  { key: "stale_3", state: "stale_3", label: "mk_kpi_stale_3", icon: "", color: "#c2410c", tint: "#ffedd5" },
  { key: "stale_7", state: "stale_7", label: "mk_kpi_stale_7", icon: "", color: "#b91c1c", tint: "#fee2e2" },
  { key: "posted_today", state: "posted_today", label: "mk_kpi_posted_today", icon: "", color: "#4d7c0f", tint: "#eaf9d2" },
];

/* ตัวเลือกการเรียง — ตัวแรกคือค่าตั้งต้นของหน้า (เพิ่งโพสต์ล่าสุดขึ้นก่อน)
   บันทึกโพสต์เสร็จแล้วแถวนั้นจะขึ้นมาอยู่บนสุด เห็นผลทันทีว่าบันทึกติดแล้ว
   ส่วนคนที่จะไล่เก็บงานค้าง เลือก "ค้างนานสุดขึ้นก่อน" ที่อยู่ถัดลงมาได้ */
const SORTS = [
  { value: "posted_desc", label: "mk_sort_recent_first" },
  { value: "posted_asc", label: "mk_sort_stale_first" },
  { value: "coverage_asc", label: "mk_sort_coverage_asc" },
  { value: "coverage_desc", label: "mk_sort_coverage_desc" },
  { value: "rent_desc", label: "sort_rent_desc" },
  { value: "rent_asc", label: "sort_rent_asc" },
  { value: "code_asc", label: "mk_sort_code" },
  { value: "updated_desc", label: "sort_updated_desc" },
];

/* ----------------------------------------------- แท็บในแผงรายละเอียดทรัพย์
 * 4 แท็บแรกเรียงตามลำดับเดียวกับ "ขั้นตอน" ของหน้าเพิ่ม-แก้ไขทรัพย์ คนที่เคยกรอก
 * ทรัพย์มาแล้วจะรู้ทันทีว่าข้อมูลแต่ละชุดอยู่แท็บไหน ส่วน "การตลาด" ต่อท้ายไว้
 * เพราะไม่ได้เป็นข้อมูลของตัวทรัพย์ แต่เป็นงานที่ทำกับทรัพย์
 *
 * เปิดมาที่ "การตลาด" เสมอ (ไม่ใช่แท็บแรก) เพราะแผงนี้ถูกเปิดจากคิวงานโพสต์ —
 * ตอบงานที่กำลังทำอยู่ก่อน แล้วค่อยให้ย้อนไปดูข้อมูลทรัพย์ประกอบเมื่ออยากรู้
 * ------------------------------------------------------------------------- */
const DRAWER_TABS = [
  { key: "info", label: "mk_tab_info", icon: "" },
  { key: "photo", label: "mk_tab_photo", icon: "" },
  { key: "owner", label: "mk_tab_owner", icon: "" },
  { key: "note", label: "mk_tab_note", icon: "" },
  { key: "marketing", label: "mk_tab_marketing", icon: "" },
];

/* --------------------------------------------------------- มุมมองของหน้านี้
 * ตาราง  : "ทรัพย์ตัวไหนค้าง" — แถวละ 1 ทรัพย์ ใช้ไล่เก็บงานทีละตัว
 * ปฏิทิน : "เดือนนี้ทีมทำงานไปวันไหนบ้าง วันไหนหาย" — ช่องละ 1 วัน
 * ทั้งสองมุมมองใช้ตัวกรองชุดเดียวกัน สลับแล้วขอบเขตข้อมูลไม่เปลี่ยน */
const VIEWS = [
  { value: "table", label: "mk_view_table", icon: "\uf0ce" },
  { value: "calendar", label: "mk_view_calendar", icon: "\uf073" },
];

/* หัวคอลัมน์ของปฏิทิน — เริ่มวันอาทิตย์ตามปฏิทินไทย (ตรงกับ Date.getDay() พอดี) */
const WEEKDAYS = ["mk_dow_sun", "mk_dow_mon", "mk_dow_tue", "mk_dow_wed", "mk_dow_thu", "mk_dow_fri", "mk_dow_sat"];

/* จุดสีช่องทางที่โชว์บนช่องวัน ที่เหลือย่อเป็น "+N" — ช่องวันเล็กเกินกว่าจะใส่ครบทุกช่อง */
const CAL_CHIP_LIMIT = 4;

/* ภาษาของรายละเอียดประกาศ — โชว์เฉพาะภาษาที่กรอกไว้จริง (ชุดเดียวกับหน้ารวมทรัพย์) */
const DESC_LANGS = [
  { value: "th", label: "lang_thai", field: "description_th" },
  { value: "en", label: "lang_english", field: "description_en" },
  { value: "cn", label: "lang_chinese", field: "description_cn" },
];

/* จำนวนประวัติที่โชว์ตอนเปิดแผง — ที่เหลือซ่อนไว้หลังปุ่ม "ดูประวัติทั้งหมด"
   ทรัพย์ที่โพสต์ถี่ ๆ มีประวัติหลายสิบแถว ถ้ากางหมดตั้งแต่แรกจะกลบทุกอย่างที่อยู่ข้างบน */
const HISTORY_PREVIEW = 5;

/* จำนวนชิปช่องทางที่โชว์บนแถว ที่เหลือย่อเป็น "+N"
   นับเฉพาะช่องที่โพสต์ไปแล้ว — คอลัมน์นี้ตอบว่า "ทำอะไรไปแล้วบ้าง"
   ส่วนที่ยังไม่ได้ทำมีคอลัมน์ความคืบหน้าบอกอยู่แล้ว ไม่ต้องเอาไอคอนจาง ๆ มาแย่งพื้นที่ */
const CHIP_LIMIT = 3;

/* ------------------------------------------------------------------ ตัวกรอง */
const EMPTY_FILTER = {
  keyword: "",
  status: "available", // หน้านี้สนใจทรัพย์ที่ยังว่างเป็นหลัก
  type: "",
  rent_min: "",
  rent_max: "",
  channel: "",
  channel_mode: "posted",
  state: "",
  deals: [],
  district: "",
  admin: "",
};

/* ---------------------------------------------------------------- ตัวช่วย */
const pad = (v) => String(v).padStart(2, "0");

/* ------------------------------------------------------- ตัวช่วยของปฏิทิน
 * เดือนถูกเก็บเป็นสตริง "YYYY-MM" ตลอด ไม่ใช่ออบเจ็กต์ Date — ส่งเข้า API ได้ตรง ๆ
 * และเทียบเท่ากันได้ด้วย === โดยไม่ต้องระวังเรื่องเวลา/เขตเวลาที่ติดมากับ Date
 * ------------------------------------------------------------------------- */
const monthOf = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}`;

/**
 * "YYYY-MM-DD" เป็น Date ของวันนั้นตามเวลาเครื่อง
 *
 * new Date("2026-08-01") ถูกอ่านเป็นเที่ยงคืน UTC ตามสเปก เครื่องที่อยู่โซนลบจะได้
 * วันก่อนหน้าไปเลย (ชื่อเดือนบนหัวปฏิทินเพี้ยนทั้งเดือน) ไทยเป็นโซนบวกจึงไม่โดน
 * แต่ไม่มีเหตุผลที่จะฝากความถูกต้องไว้กับโซนเวลาของเครื่องที่เปิดหน้าเว็บ
 */
const dateOf = (value) => {
  const [year, month, day] = String(value).split("-").map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
};

const shiftMonth = (month, delta) => {
  const [year, m] = String(month).split("-").map(Number);
  return monthOf(new Date(year, m - 1 + delta, 1));
};

/**
 * ช่องทั้งหมดของตารางปฏิทิน 1 เดือน — เริ่มวันอาทิตย์ของสัปดาห์แรก จบวันเสาร์ของสัปดาห์สุดท้าย
 *
 * วันของเดือนข้างเคียงส่งไปด้วย (out: true) แทนที่จะเป็นช่องว่าง เพื่อให้ตารางเต็มกรอบ
 * เหมือนปฏิทินของเมนูนัดหมาย — เส้นตารางจะได้ไม่ขาดหายเป็นรูตรงหัวท้ายเดือน
 */
const monthCells = (month) => {
  const [year, m] = String(month).split("-").map(Number);
  const lead = new Date(year, m - 1, 1).getDay();      // 0 = อาทิตย์
  const last = new Date(year, m, 0);                   // วันที่ 0 ของเดือนถัดไป = วันสุดท้ายของเดือนนี้
  const total = lead + last.getDate() + (6 - last.getDay());

  return Array.from({ length: total }, (_, i) => {
    const date = new Date(year, m - 1, 1 - lead + i);
    return {
      key: `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
      date,
      out: date.getMonth() !== m - 1,
    };
  });
};

const money = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
const decimal = (v) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
const dateTH = (v) => (v ? format_date(v, "dd/mm/yyyy", "th") : "-");
const share = (part, whole) => (whole ? ((part / whole) * 100).toFixed(1) : "0.0");
const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const categoryName = (category) => (category ? (isTh() ? category.name_th : category.name_en || category.name_th) : "-");
const channelName = (channel) => (channel ? (isTh() ? channel.name_th : channel.name_en || channel.name_th) : "");
// อักษรย่อของผู้รับผิดชอบ ใช้ทำวงกลมแทนรูปโปรไฟล์ (ระบบยังไม่มีรูปผู้ใช้)
const initials = (name) => String(name || "?").trim().charAt(0);

/** จำนวนวันเต็มที่ผ่านมาแล้วนับจากวันของ value ถึงวันนี้ — null = ไม่มีค่า */
const daysSince = (value) => {
  if (!value) return null;
  const then = new Date(value);
  if (Number.isNaN(then.getTime())) return null;
  const a = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const b = new Date();
  return Math.round((new Date(b.getFullYear(), b.getMonth(), b.getDate()) - a) / 86400000);
};

/** เวลาแบบอ่านเร็ว : วันนี้/เมื่อวาน โชว์เวลาด้วย เกินกว่านั้นนับเป็นจำนวนวัน */
const relativeTime = (value) => {
  const days = daysSince(value);
  if (days === null) return "-";
  if (days <= 0) return `${t("mk_today")} ${format_date(value, "hh:mm", "en")}`;
  if (days === 1) return `${t("mk_yesterday")} ${format_date(value, "hh:mm", "en")}`;
  if (days < 30) return `${days} ${t("mk_days_ago")}`;
  return format_date(value, "dd/mm/yyyy", "th");
};

/**
 * จัดประวัติการโพสต์เป็นกลุ่มตามวัน — ไทม์ไลน์ยาว ๆ อ่านยากถ้าไม่มีหัววันคั่น
 * และวันเดียวกันไม่ต้องเขียนวันที่ซ้ำทุกแถว เหลือแต่เวลาก็พอ
 * (API ส่ง posts มาเรียงใหม่ไปเก่าอยู่แล้ว ลำดับกลุ่มจึงถูกต้องโดยไม่ต้องเรียงซ้ำ)
 */
const groupByDay = (posts) => {
  const groups = [];

  posts.forEach((post) => {
    const key = format_date(post.posted_at, "yyyy-mm-dd", "en");
    const last = groups[groups.length - 1];

    if (last && last.key === key) last.posts.push(post);
    else groups.push({ key, at: post.posted_at, posts: [post] });
  });

  return groups;
};

/**
 * ประกอบวันที่จาก DatePicker (Date) กับเวลาจาก input type="time" ("HH:mm")
 * เป็นรูปที่ API รับ — "YYYY-MM-DD HH:mm"
 * กรอกมาอย่างเดียวก็ได้ : ไม่ใส่วัน = วันนี้, ไม่ใส่เวลา = เวลาปัจจุบัน
 * ไม่กรอกทั้งคู่ = คืนค่าว่าง แล้วปล่อยให้ฝั่ง API ประทับเวลาให้เอง
 */
const toDateTime = (date, time) => {
  if (!date && !time) return "";
  const day = format_date(date || new Date(), "yyyy-mm-dd", "en");
  return `${day} ${time || format_date(new Date(), "hh:mm", "en")}`;
};

/* ค่าตั้งต้นของรายละเอียดการโพสต์ 1 ช่องทาง
   คนโพสต์ตั้งเป็นคนที่ล็อกอินอยู่ เพราะโดยมากคนกรอกก็คือคนโพสต์ */
const emptyEntry = () => ({ at: null, time: "", page_name: "", post_url: "", user: getProfile()?.uid || "", note: "" });

class Marketing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: { ...EMPTY_FILTER },   // ตัวกรองในการ์ดกรอง (ยังไม่กดค้นหา)
      applied: { ...EMPTY_FILTER },  // ตัวกรองที่ใช้กับผลลัพธ์ปัจจุบัน
      sort: SORTS[0].value,
      page: 1,
      data: [],
      count: 0,
      summary: null,

      /* มุมมองของหน้า — ตาราง (ตั้งต้น) หรือปฏิทิน ใช้ตัวกรองชุดเดียวกันทั้งคู่
         cal_month = เดือนที่กำลังดู "YYYY-MM"
         cal_days  = ยอดรายวันของเดือนนั้น (เฉพาะวันที่มีโพสต์ — วันว่างไม่ถูกส่งมา)
         cal_date  = วันที่กดเลือกอยู่ ("" = ยังไม่เลือก) พร้อมรายการโพสต์ของวันนั้น */
      view: "table",
      cal_month: monthOf(new Date()),
      cal_days: [],
      cal_assets: 0,
      cal_date: "",
      cal_posts: [],
      cal_total: 0,

      // ตัวเลือกของตัวกรอง โหลดครั้งเดียวตอนเปิดหน้า
      channels: [],
      categories: [],
      admins: [],
      zones: [],

      /* ทรัพย์ที่ติ๊กเลือกไว้ในตาราง — เก็บเป็น uid -> ตัวรายการ ไม่ใช่แค่ uid
         เพราะติ๊กสะสมข้ามหน้าได้ พอเปลี่ยนหน้าแล้วของหน้าเดิมจะไม่อยู่ใน data แล้ว
         แต่ยังต้องเอาชื่อ/สถานะช่องทางของมันมาโชว์ในโมดัลอยู่ */
      selected: {},

      // uid ของทรัพย์ที่เพิ่งบันทึกโพสต์ไปเมื่อครู่ — ใช้ไฮไลต์แถวชั่วคราว
      flash: [],

      /* โมดัลบันทึกการโพสต์ — ระบุรายละเอียดแยกรายช่องทางทั้งหมด
         (วันเวลา · กลุ่ม/เพจ · ลิงก์ · คนโพสต์ · โน้ต) เพราะของจริงมักไม่เหมือนกัน
         ใช้ฟอร์มเดียวกันทั้ง 2 โหมด ต่างกันแค่ปลายทางที่บันทึกลง
           single : ทรัพย์รายการเดียว (post_item)
           bulk   : ทุกรายการที่ติ๊กไว้ ใช้ค่าชุดเดียวกันทั้งหมด (post_targets) */
      post_open: false,
      post_mode: "single",
      post_item: null,
      post_targets: [],
      post_channels: [],             // uid ช่องทางที่ติ๊กไว้
      post_entries: {},              // uid ช่องทาง -> { at, time, page_name, post_url, user, note }

      // โมดัลดูช่องทางทั้งหมดของทรัพย์ 1 รายการ (เปิดจากปุ่ม +N ในตาราง — ดูอย่างเดียว)
      chan_open: false,
      chan_item: null,

      /* แผงรายละเอียดทรัพย์ — สไลด์เข้ามาทางขวา (ไม่ใช่โมดัลกลางจอ)
         เพราะเป็นการ "เปิดดูรายละเอียดของแถว" ตารางเบื้องหลังจึงควรยังเห็นอยู่

         history_item  = ทรัพย์ในรูปของหน้าการตลาด (ช่องทาง/ความคืบหน้า)
         history_asset = รายละเอียดเต็มของทรัพย์ (GET admin/assets/:uid) ที่แท็บอื่นใช้
                         ดึงพร้อมประวัติตั้งแต่ตอนเปิดแผง สลับแท็บจะได้ไม่ต้องรอโหลด */
      history_open: false,
      history_tab: "marketing",
      history_item: null,
      history_asset: null,
      history_posts: [],
      history_total: 0,
      history_channel: "",  // ช่องทางที่กรองอยู่ในไทม์ไลน์ ("" = ทุกช่องทาง)
      history_all: false,   // กาง 5 รายการล่าสุด หรือกางทั้งหมดแล้ว
      history_photo: 0,     // รูปที่กำลังดูอยู่ในแท็บรูปภาพ
      history_lang: "th",   // ภาษาของรายละเอียดประกาศในแท็บข้อมูลทรัพย์

      /* ชุดไฟล์ที่กำลังรวม zip อยู่ ("" = ว่าง) — ล็อกปุ่มไว้ทั้งสองการ์ดระหว่างรอ
         เพราะ API รวมไฟล์ทีละคำขอ กดซ้อนกันจะได้ zip ซ้อนกันหลายก้อน */
      downloading: "",

      /* ปุ่มคัดลอกรายละเอียดเปลี่ยนเป็นข้อความ "คัดลอกแล้ว" ชั่วคราวแทนการเด้ง popup */
      copied: false,

      /* โมดัลแก้บันทึกการโพสต์ที่ลงไปแล้ว — แก้ได้ทั้งใบรวมถึงย้ายช่องทาง
         (บันทึกผิดช่องคือความผิดพลาดที่เจอบ่อยสุด เดิมต้องลบทิ้งแล้วบันทึกใหม่) */
      edit_open: false,
      edit_post: null,
      edit_form: emptyEntry(),
      edit_channel: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.GetMaster();
    this.Get(1);
  }

  componentWillUnmount() {
    clearTimeout(this.flashTimer);
    clearTimeout(this.copiedTimer);
  }

  /* ตัวเลือกของตัวกรอง — ช่องทาง/ประเภททรัพย์/ผู้ดูแล/ทำเล ดึงจากข้อมูลจริงทั้งหมด */
  GetMaster = async () => {
    const [channels, categories, admins, zones] = await Promise.all([
      GET("admin/marketing-channels", { page: 0, is_active: true }),
      GET("admin/asset-categories", { page: 0, is_active: true }),
      GET("admin/users", { page: 0, is_active: true }),
      GET("admin/assets/zones", null),
    ]);

    this.setState({
      channels: channels?.status ? channels.data || [] : [],
      categories: categories?.status ? categories.data || [] : [],
      admins: admins?.status ? admins.data || [] : [],
      zones: zones?.status ? zones.data || [] : [],
    });
  };

  /* ------------------------------------------------------------ ดึงผลการค้นหา */
  Get = async (page = 1, filter = this.state.filter, sort = this.state.sort) => {
    loading(true);
    const [result, summary] = await Promise.all([
      GET("admin/marketing", this.query(page, filter, sort)),
      // การ์ดสรุปใช้ตัวกรองชุดเดียวกันแต่ไม่รวมตัวกรอง "สถานะการโพสต์"
      // (ไม่งั้นกดการ์ดหนึ่งแล้วตัวเลขบนการ์ดอื่นจะเปลี่ยนตาม จนเทียบกันไม่ได้)
      GET("admin/marketing/summary", this.query(0, { ...filter, state: "" }, sort)),
    ]);
    loading(false);

    if (!result?.status) return [];

    const data = result.data || [];

    /* ของที่ติ๊กค้างไว้แล้วโผล่มาในผลลัพธ์รอบนี้ ให้ใช้ข้อมูลชุดใหม่แทนของเดิม
       ไม่งั้นสถานะช่องทางในโมดัลบันทึกชุดจะเป็นภาพเก่าตั้งแต่ตอนที่ติ๊ก */
    const selected = { ...this.state.selected };
    data.forEach((item) => selected[item.uid] && (selected[item.uid] = item));

    this.setState({
      data,
      selected,
      count: result.pagination?.count || 0,
      summary: summary?.status ? summary.data : this.state.summary,
      page,
      applied: { ...filter },
      sort,
    });

    // ปฏิทินใช้ตัวกรองชุดเดียวกัน เปลี่ยนตัวกรองแล้วต้องดึงใหม่ทั้งคู่ให้ตรงกัน
    if (this.state.view === "calendar") this.GetCalendar(this.state.cal_month, filter);

    // คืนรายการของรอบนี้ให้ผู้เรียกเช็กต่อได้ทันที (this.state ยังเป็นค่าเก่าตอน setState ยังไม่ commit)
    return data;
  };

  /* ============================================================= มุมมองปฏิทิน
   * มองงานชุดเดียวกับตาราง แต่คนละแกน — ตารางถามว่า "ทรัพย์ตัวไหนค้าง"
   * ปฏิทินถามว่า "เดือนนี้ทีมทำงานไปวันไหนบ้าง วันไหนหาย"
   *
   * โหลดเป็น 2 จังหวะ : ยอดรายวันของทั้งเดือนก้อนเดียว แล้วค่อยโหลดรายการโพสต์
   * ของ "วันที่กดเลือก" ทีหลัง — เดือนที่ยกชุดขึ้นทุกวันมีเป็นพันแถว ส่งมาพร้อมกัน
   * ทั้งเดือนคือโหลดของที่แทบไม่มีใครดูทั้งหมด
   * ------------------------------------------------------------------------- */
  GetCalendar = async (month = this.state.cal_month, filter = this.state.applied) => {
    loading(true);
    const result = await GET("admin/marketing/calendar", this.query(0, filter, "", { month }));
    loading(false);

    if (!result?.status) return;

    const days = result.data?.days || [];
    /* วันที่เลือกค้างไว้อาจไม่มีอยู่ในเดือนใหม่ที่เพิ่งเลื่อนมา ต้องปล่อยทิ้ง
       ไม่งั้นรายการด้านล่างจะเป็นของเดือนก่อนทั้งที่ปฏิทินเปลี่ยนไปแล้ว */
    const keep = this.state.cal_date.startsWith(`${month}-`);

    this.setState({
      cal_month: month,
      cal_days: days,
      cal_assets: result.data?.assets || 0,
      ...(keep ? {} : { cal_date: "", cal_posts: [], cal_total: 0 }),
    });

    // เลือกวันค้างไว้และยังอยู่ในเดือนเดิม = ต้องดึงรายการของวันนั้นใหม่ด้วย (ตัวกรองอาจเปลี่ยน)
    if (keep) this.GetCalendarDay(this.state.cal_date, filter);
  };

  GetCalendarDay = async (date, filter = this.state.applied) => {
    const result = await GET(`admin/marketing/calendar/${date}`, this.query(0, filter, ""));
    if (!result?.status) return;

    this.setState({
      cal_date: result.data?.date || date,
      cal_posts: result.data?.posts || [],
      cal_total: result.data?.total || 0,
    });
  };

  /** กดวันเดิมซ้ำ = ปิดรายการของวันนั้น (เหมือนกดการ์ดสรุปซ้ำแล้วยกเลิกการกรอง) */
  PickDay = (date) => {
    if (this.state.cal_date === date) {
      this.setState({ cal_date: "", cal_posts: [], cal_total: 0 });
      return;
    }

    loading(true);
    this.GetCalendarDay(date).finally(() => loading(false));
  };

  SwitchView = (view) => {
    if (view === this.state.view) return;
    // เข้าปฏิทินครั้งแรกค่อยโหลด — คนที่ใช้แต่ตารางจะได้ไม่ต้องจ่ายค่าคิวรีนี้ทุกครั้งที่เปิดหน้า
    this.setState({ view }, () => view === "calendar" && this.GetCalendar());
  };

  ChangeMonth = (delta) => this.GetCalendar(shiftMonth(this.state.cal_month, delta));

  /* บันทึก/แก้/ลบ ทุกทางเรียก Get() อยู่แล้ว และ Get() ดึงปฏิทินตามให้เองเมื่อกำลังดูปฏิทินอยู่
     จึงไม่ต้องมีตัวรีเฟรชแยกอีกตัว — ที่เดียวจบ ไม่มีทางลืมเรียกข้างใดข้างหนึ่ง */

  /* แปลงตัวกรองเป็น query ของ API — ตัดคีย์ที่ไม่ได้ใช้ทิ้งก่อนส่ง */
  query = (page, filter, sort, extra = {}) => {
    const params = {
      page,
      page_size: PAGE_SIZE,
      sort,
      data_search: filter.keyword,
      status: filter.status,
      type: filter.type,
      rent_min: filter.rent_min,
      rent_max: filter.rent_max,
      channel_uid: filter.channel,
      channel_mode: filter.channel ? filter.channel_mode : "",
      state: filter.state,
      deals: (filter.deals || []).join(","),
      district: filter.district,
      admin_uid: filter.admin,
      ...extra,
    };

    return Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== "" && value !== false && value !== null && value !== undefined)
    );
  };

  /* ------------------------------------------------------------ จัดการตัวกรอง
   * ทุกช่องในการ์ดกรองแค่แก้ค่าในฟอร์ม ยังไม่ยิงค้นหา — ต้องกดปุ่ม "ค้นหา" ถึงจะมีผล
   * (เลือกหลายช่องติด ๆ กันจะได้ไม่โหลดใหม่ทุกครั้งที่กด)
   * ยกเว้นการ์ดสรุปด้านบนกับปุ่มล้างค่า ที่กดแล้วเห็นผลทันทีตามที่คาดหวัง
   * ------------------------------------------------------------------------- */
  setFilter = (patch) => this.setState((prev) => ({ filter: { ...prev.filter, ...patch } }));

  applyFilter = (patch) => {
    const filter = { ...this.state.filter, ...patch };
    this.setState({ filter }, () => this.Get(1, filter));
  };

  // กดการ์ดสรุปซ้ำ = ยกเลิกการกรองด้วยการ์ดนั้น
  applyState = (state) => this.applyFilter({ state: this.state.applied.state === state ? "" : state });

  clearAll = () => this.applyFilter({ ...EMPTY_FILTER });

  /* ================================================== เลือกทรัพย์หลายรายการ
   * ติ๊กสะสมข้ามหน้าได้ — เลือกจากหน้านี้บ้างหน้าถัดไปบ้าง แล้วค่อยบันทึกทีเดียว
   * การเลือกจึงไม่ถูกล้างตอนเปลี่ยนหน้าหรือค้นหาใหม่ ล้างเมื่อกด "ยกเลิกการเลือก"
   * หรือเมื่อบันทึกสำเร็จเท่านั้น (จำนวนที่เลือกอยู่โชว์บนปุ่มตลอดเวลา)
   * ------------------------------------------------------------------------- */
  toggleSelect = (item) =>
    this.setState((prev) => {
      const selected = { ...prev.selected };
      if (selected[item.uid]) delete selected[item.uid];
      else selected[item.uid] = item;
      return { selected };
    });

  /** ติ๊ก/เอาออกทั้งหน้าปัจจุบัน (ไม่ยุ่งกับที่เลือกไว้จากหน้าอื่น) */
  toggleSelectPage = () =>
    this.setState((prev) => {
      const selected = { ...prev.selected };
      const allOnPage = prev.data.length > 0 && prev.data.every((item) => selected[item.uid]);

      prev.data.forEach((item) => {
        if (allOnPage) delete selected[item.uid];
        else selected[item.uid] = item;
      });

      return { selected };
    });

  ClearSelection = () => this.setState({ selected: {} });

  /* ======================================================= บันทึกการโพสต์ */

  /**
   * เปิดโมดัลบันทึกการโพสต์ของทรัพย์ 1 รายการ
   * เริ่มต้นไม่ติ๊กช่องทางไว้ให้เลย — ผู้ใช้เลือกเองว่ารอบนี้โพสต์ที่ไหนไปบ้าง
   * (ติ๊กไว้ล่วงหน้าแล้วเผลอกดบันทึกทั้งชุด จะได้ประวัติที่ไม่ตรงกับความจริง)
   */
  OpenPost = (item) => {
    this.setState({
      post_open: true,
      post_mode: "single",
      post_item: item,
      post_targets: [],
      post_channels: [],
      post_entries: {},
    });
  };

  /** เปิดฟอร์มเดียวกัน แต่บันทึกให้ทุกรายการที่ติ๊กไว้ด้วยข้อมูลชุดเดียวกัน */
  OpenBulkPost = () => {
    const targets = Object.values(this.state.selected);
    if (!targets.length) return;

    if (targets.length > MAX_BULK) {
      alert("", "warning", t("warning"), `${t("mk_bulk_max")} ${MAX_BULK} ${t("unit_items")}`);
      return;
    }

    this.setState({
      post_open: true,
      post_mode: "bulk",
      post_item: null,
      post_targets: targets,
      post_channels: [],
      post_entries: {},
    });
  };

  ClosePost = () => this.setState({ post_open: false });

  /* ติ๊ก/เอาช่องทางออก
     เอาออกต้องยืนยันก่อน เพราะการ์ดรายละเอียดของช่องนั้นจะหายไปจากหน้าจอทันที
     (ค่าที่กรอกไว้ยังถูกเก็บไว้ ติ๊กกลับเข้ามาแล้วได้ของเดิมคืน ไม่ต้องกรอกใหม่) */
  togglePostChannel = async (uid) => {
    const { post_channels, channels } = this.state;

    if (post_channels.includes(uid)) {
      const channel = channels.find((c) => c.uid === uid);
      const ok = await alert(
        "",
        "warning",
        t("mk_remove_channel"),
        `${t("mk_remove_channel_confirm")}\n${channelName(channel)}`,
        t("confirm"),
        t("cancel")
      );
      if (!ok) return;

      this.setState((prev) => ({ post_channels: prev.post_channels.filter((e) => e !== uid) }));
      return;
    }

    this.setState((prev) => ({
      post_channels: [...prev.post_channels, uid],
      post_entries: prev.post_entries[uid] ? prev.post_entries : { ...prev.post_entries, [uid]: emptyEntry() },
    }));
  };

  /** ติ๊กทุกช่อง / ล้างทั้งหมด จากลิงก์เหนือรายการช่องทาง */
  setAllChannels = async (on) => {
    if (!on) {
      if (!this.state.post_channels.length) return;
      // ล้างทั้งหมดคือการเอาช่องทางออกทีเดียวหลายช่อง จึงต้องยืนยันเหมือนกัน
      const ok = await alert("", "warning", t("clear_all"), t("mk_clear_channels_confirm"), t("confirm"), t("cancel"));
      if (!ok) return;

      this.setState({ post_channels: [] });
      return;
    }

    this.setState((prev) => {
      const uids = prev.channels.map((c) => c.uid);
      return {
        post_channels: uids,
        post_entries: uids.reduce((acc, uid) => ({ ...acc, [uid]: prev.post_entries[uid] || emptyEntry() }), {}),
      };
    });
  };

  /** แก้ค่าใดค่าหนึ่งของรายละเอียดช่องทางนั้น */
  setEntry = (uid, patch) =>
    this.setState((prev) => ({
      post_entries: { ...prev.post_entries, [uid]: { ...(prev.post_entries[uid] || emptyEntry()), ...patch } },
    }));

  /**
   * แก้วันที่/เวลาที่โพสต์ — ห้ามเกินตอนนี้
   *
   * หน้านี้คือการ "บันทึกสิ่งที่ทำไปแล้ว" ไม่ใช่ตั้งเวลาโพสต์ล่วงหน้า วันเวลาในอนาคต
   * จะทำให้คิวเพี้ยนทั้งกระดาน (ทรัพย์ตัวนั้นจะนับว่าโพสต์ล่าสุดตลอด ไม่ค้างสักที)
   * ปฏิทินปิดวันอนาคตไว้แล้ว ที่นี่กันอีกชั้นเผื่อพิมพ์วันที่เองหรือเลือกเวลาเลยจากตอนนี้
   * — ดึงกลับมาเป็นเวลาปัจจุบันให้ พร้อมขึ้นข้อความบอก ไม่แก้ให้เงียบ ๆ
   */
  setEntryWhen = (uid, patch) =>
    this.setState((prev) => {
      const entry = { ...(prev.post_entries[uid] || emptyEntry()), ...patch };
      const now = new Date();
      const picked = entry.at || entry.time ? new Date(toDateTime(entry.at, entry.time).replace(" ", "T")) : null;
      const future = !!picked && !Number.isNaN(picked.getTime()) && picked.getTime() > now.getTime();

      if (future) {
        entry.at = format_date(now, "yyyy-mm-dd", "en");
        entry.time = format_date(now, "hh:mm", "en");
      }
      entry.future = future;

      return { post_entries: { ...prev.post_entries, [uid]: entry } };
    });

  SavePost = async () => {
    const { post_mode, post_item, post_targets, post_channels, post_entries } = this.state;
    const bulk = post_mode === "bulk";

    if (!post_channels.length) {
      alert("", "warning", t("warning"), t("mk_pick_channel_first"));
      return;
    }

    /* บันทึกหลายรายการเขียนประวัติทีเดียวหลายสิบแถว และย้อนกลับได้ทีละแถวเท่านั้น
       จึงทวนจำนวนที่กำลังจะเกิดขึ้นให้เห็นก่อน (รายการ × ช่องทาง = แถวที่จะบันทึก) */
    if (bulk) {
      const rows = post_targets.length * post_channels.length;
      const ok = await alert(
        "",
        "warning",
        t("mk_bulk_log_post"),
        `${post_targets.length} ${t("unit_items")} × ${post_channels.length} ${t("mk_channel_selected")} = ${money(rows)} ${t("mk_unit_posts")}`,
        t("confirm"),
        t("cancel")
      );
      if (!ok) return;
    }

    /* ทุกช่องทางระบุวันเวลาของตัวเอง — ช่องที่เว้นว่างไม่ต้องส่งไป
       ปล่อยให้ฝั่ง API ประทับเวลาปัจจุบันให้เอง */
    const entries = post_channels.map((uid) => {
      const entry = post_entries[uid] || {};
      const posted_at = toDateTime(entry.at, entry.time);
      const text = (value) => String(value || "").trim();

      return {
        channel_uid: uid,
        ...(posted_at ? { posted_at } : {}),
        ...(text(entry.page_name) ? { page_name: text(entry.page_name) } : {}),
        ...(text(entry.post_url) ? { post_url: text(entry.post_url) } : {}),
        ...(entry.user ? { user_uid: entry.user } : {}),
        ...(text(entry.note) ? { note: text(entry.note) } : {}),
      };
    });

    const saved = bulk ? post_targets.map((item) => item.uid) : [post_item.uid];

    loading(true);
    const result = bulk
      ? await POST("admin/marketing/posts", { assets: saved, entries })
      : await POST(`admin/marketing/${post_item.uid}/posts`, { entries });
    loading(false);

    if (!result?.status) return;

    // บันทึกให้ชุดที่เลือกไปแล้ว = งานชุดนั้นจบ ปล่อยการเลือกทิ้งไปด้วยเลย
    this.setState({ post_open: false, flash: saved, ...(bulk ? { selected: {} } : {}) });
    const rows = await this.Get(this.state.page, this.state.applied);

    /* บันทึกเสร็จแล้วลำดับของแถวเปลี่ยนทันทีตามการเรียงที่เลือกไว้ — ค่าตั้งต้นคือ
       "โพสต์ล่าสุดก่อน" แถวจึงขึ้นไปอยู่บนสุดของหน้าแรก ถ้าตอนนั้นยืนอยู่หน้าอื่น
       (หรือกรองด้วยการ์ด "ยังไม่ได้โพสต์วันนี้" อยู่ ซึ่งแถวจะหลุดออกจากผลการค้นหา)
       แถวจะหายไปจากจอเฉย ๆ จนเข้าใจผิดว่าบันทึกไม่ติด กรณีนั้นต้องบอกให้รู้ */
    const stillHere = rows.some((item) => saved.includes(item.uid));
    const note = stillHere ? "" : `\n${t("mk_post_saved_moved")}`;

    alert("", "success", t("success"), `${t("mk_post_saved")} ${result.data?.posts || 0} ${t("mk_unit_posts")}${note}`);

    // ไฮไลต์แถวที่เพิ่งบันทึกไว้ครู่หนึ่ง เห็นชัด ๆ ว่าข้อมูลที่เปลี่ยนคือแถวไหน
    clearTimeout(this.flashTimer);
    this.flashTimer = setTimeout(() => this.setState({ flash: [] }), 4000);
  };

  /* ------------------------------------------------- ดูช่องทางทั้งหมดของทรัพย์
   * เปิดจากปุ่ม +N ในตาราง — คอลัมน์นั้นโชว์ได้แค่ 3 ชิป ที่เหลือต้องมีที่ให้ดู
   * ข้อมูลมากับแถวอยู่แล้ว ไม่ต้องยิง API ใหม่ และไม่มีปุ่มสั่งงานใด ๆ ในโมดัลนี้
   * ------------------------------------------------------------------------- */
  OpenChannels = (item) => this.setState({ chan_open: true, chan_item: item });

  CloseChannels = () => this.setState({ chan_open: false });

  /* =============================================== แผงรายละเอียดทรัพย์ (สไลด์ขวา)
   * ดึง 2 ก้อนพร้อมกันตั้งแต่ตอนเปิด
   *   admin/marketing/:uid/posts — ประวัติการโพสต์ + ทรัพย์ในรูปของหน้าการตลาด
   *   admin/assets/:uid          — รายละเอียดเต็มของทรัพย์ที่แท็บอื่นใช้
   * โหลดทีเดียวจบแล้วสลับแท็บได้ทันทีโดยไม่ต้องรอ ซึ่งสำคัญกว่าการประหยัดคำขอ
   * เพราะคนเปิดแผงมักกวาดดูหลายแท็บติดกัน
   *
   * ทรัพย์ที่ถูกลบไปแล้วยังเปิดประวัติได้ (ก้อนที่ 2 พังก็ไม่เป็นไร แท็บอื่นจะขึ้นว่าไม่มีข้อมูล)
   * ------------------------------------------------------------------------- */
  OpenHistory = async (item) => {
    loading(true);
    const [result, asset] = await Promise.all([
      GET(`admin/marketing/${item.uid}/posts`, null),
      GET(`admin/assets/${item.uid}`, null),
    ]);
    loading(false);

    if (!result?.status) return;

    this.setState({
      history_open: true,
      history_item: result.data?.asset || item,
      history_asset: asset?.status ? asset.data : null,
      history_posts: result.data?.posts || [],
      // ประวัติที่ส่งมาถูกตัดมาแล้วตามที่แผงแสดงไหว ยอดรวมจึงใช้ค่าจาก API ไม่ใช่ความยาวของ array
      history_total: result.data?.total || 0,
      /* เปิดทรัพย์รายการใหม่ = เริ่มนับหนึ่งใหม่ทุกอย่าง ไม่ค้างสถานะของทรัพย์ตัวก่อน
         (แท็บการตลาด · ไม่กรองช่องทาง · ประวัติย่อ · รูปแรก) */
      history_tab: "marketing",
      history_channel: "",
      history_all: false,
      history_photo: 0,
      history_lang: "th",
    });
  };

  CloseHistory = () => this.setState({ history_open: false });

  /** ดึงประวัติของทรัพย์ที่เปิดค้างอยู่ใหม่ — ใช้หลังแก้/ลบบันทึก ให้แผงตรงกับฐานข้อมูลทันที */
  ReloadHistory = async () => {
    const item = this.state.history_item;
    if (!item) return;

    const result = await GET(`admin/marketing/${item.uid}/posts`, null);
    if (!result?.status) return;

    this.setState({
      history_item: result.data?.asset || item,
      history_posts: result.data?.posts || [],
      history_total: result.data?.total || 0,
    });
  };

  DeletePost = async (post) => {
    if (!(await alert("", "warning", t("mk_delete_post"), t("mk_delete_post_desc"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await DELETE(`admin/marketing/posts/${post.uid}`, null);
    loading(false);

    if (!result?.status) return;

    /* ตัดแถวออกจากรายการที่ถืออยู่ก่อน แผงจะได้ตอบสนองทันทีโดยไม่ต้องรอ API รอบสอง
       แล้วค่อยดึงประวัติใหม่ให้ครบ (ประวัติถูกตัดมา ลบ 1 แถวอาจมีของเก่าโผล่มาแทน)
       และดึงตารางใหม่ เพราะความคืบหน้า/โพสต์ล่าสุดของแถวนั้นเปลี่ยนไปแล้ว */
    this.setState((prev) => ({
      history_posts: prev.history_posts.filter((e) => e.uid !== post.uid),
      history_total: Math.max(0, prev.history_total - 1),
    }));
    await Promise.all([this.ReloadHistory(), this.Get(this.state.page, this.state.applied)]);
    alert("", "success", t("success"), t("mk_delete_post_done"));
  };

  /* --------------------------------------------- แก้บันทึกการโพสต์ที่ลงไปแล้ว
   * เปิดฟอร์มเดี่ยวที่มีค่าเดิมครบทุกช่อง แก้แล้วเขียนทับทั้งใบ (PUT)
   * แก้ช่องทางได้ด้วย เพราะกรณีที่เจอบ่อยสุดคือบันทึกผิดช่อง ซึ่งเดิมต้องลบทิ้ง
   * แล้วบันทึกใหม่ทั้งที่วันเวลา/ลิงก์/คนโพสต์ถูกหมด
   * ------------------------------------------------------------------------- */
  OpenEditPost = (post) =>
    this.setState({
      edit_open: true,
      edit_post: post,
      edit_channel: post.channel?.uid || "",
      edit_form: {
        at: post.posted_at ? new Date(post.posted_at) : null,
        time: post.posted_at ? format_date(post.posted_at, "hh:mm", "en") : "",
        page_name: post.page_name || "",
        post_url: post.post_url || "",
        user: post.user?.uid || "",
        note: post.note || "",
      },
    });

  CloseEditPost = () => this.setState({ edit_open: false });

  /** แก้ค่าในฟอร์ม — ดึงวันเวลาที่เลือกล่วงหน้ากลับมาเป็นปัจจุบัน เหมือนฟอร์มบันทึกใหม่ */
  setEditForm = (patch) =>
    this.setState((prev) => {
      const form = { ...prev.edit_form, ...patch };
      const now = new Date();
      const picked = form.at || form.time ? new Date(toDateTime(form.at, form.time).replace(" ", "T")) : null;
      const future = !!picked && !Number.isNaN(picked.getTime()) && picked.getTime() > now.getTime();

      if (future) {
        form.at = format_date(now, "yyyy-mm-dd", "en");
        form.time = format_date(now, "hh:mm", "en");
      }
      form.future = future;

      return { edit_form: form };
    });

  SaveEditPost = async () => {
    const { edit_post, edit_form, edit_channel } = this.state;
    if (!edit_post) return;

    if (!edit_channel) {
      alert("", "warning", t("warning"), t("mk_pick_channel_first"));
      return;
    }

    const text = (value) => String(value || "").trim();
    /* วันเวลาต้องมีเสมอในการแก้ไข — แถวนี้มีเวลาของมันอยู่แล้ว ถ้าผู้ใช้ล้างช่องทิ้ง
       แล้วเราปล่อยให้ API ประทับเวลาปัจจุบันให้ ประวัติจะเพี้ยนโดยไม่ตั้งใจ */
    const posted_at = toDateTime(edit_form.at || new Date(edit_post.posted_at), edit_form.time);

    loading(true);
    const result = await PUT(`admin/marketing/posts/${edit_post.uid}`, {
      channel_uid: edit_channel,
      posted_at,
      page_name: text(edit_form.page_name),
      post_url: text(edit_form.post_url),
      user_uid: edit_form.user || "",
      note: text(edit_form.note),
    });
    loading(false);

    if (!result?.status) return;

    this.setState({ edit_open: false });
    await Promise.all([this.ReloadHistory(), this.Get(this.state.page, this.state.applied)]);
    alert("", "success", t("success"), t("mk_edit_post_done"));
  };

  /* ================================================ render : ชิ้นส่วนที่ใช้ซ้ำ */

  /** เครื่องหมายของช่องทาง — รูปที่อัปโหลดเอง > โลโก้แบรนด์ > ไอคอน (กติกาเดียวทั้งระบบ) */
  glyph = (channel) => channelGlyph(channel, channelName(channel));

  /* ========================================================= render : การ์ดสรุป */
  renderKpis = () => {
    const { summary, applied } = this.state;
    const data = summary || {};
    const total = data.total || 0;

    return (
      <div className="mk-kpis mk-in mb-3">
        {KPI_CARDS.map((card) => {
          const value = data[card.key] || 0;
          const active = !!card.state && applied.state === card.state;
          const label =
            card.key === "stale_3" || card.key === "stale_7"
              ? `${t(card.label)} ${(data.stale_days || [3, 7])[card.key === "stale_3" ? 0 : 1]} ${t("mk_unit_days")}`
              : t(card.label);

          return (
            <button
              key={card.key}
              type="button"
              className={`mk-kpi ${active ? "is-active" : ""}`}
              style={{ "--mk-kpi-color": card.color, "--mk-kpi-tint": card.tint }}
              // ใบแรกเป็นตัวตั้ง ไม่ใช่ตัวกรอง — กดแล้วให้กลับไปดูทั้งหมด
              onClick={() => (card.state ? this.applyState(card.state) : this.applyFilter({ state: "" }))}
              title={card.state ? t("mk_click_to_filter") : t("mk_click_to_reset")}
            >
              <div className="mk-kpi__head">
                <span className="mk-kpi__icon icon">{card.icon}</span>
                {active && <span className="icon text-12" style={{ color: card.color }}>{""}</span>}
              </div>
              <div className="mk-kpi__label">{label}</div>
              <div>
                <span className="mk-kpi__value">{money(value)}</span>
                <span className="mk-kpi__unit">{t("unit_items")}</span>
              </div>
              {/* ใบตัวตั้งไม่ต้องมีเปอร์เซ็นต์ เพราะเทียบกับตัวเองได้ 100% เสมอ */}
              <div className="mk-kpi__share">
                {card.share === false ? t("mk_kpi_total_note") : `${share(value, total)}% ${t("mk_of_vacant")}`}
              </div>
            </button>
          );
        })}
      </div>
    );
  };

  /* ======================================================== render : การ์ดกรอง
   * ตัวกรองทั้งหมดอยู่ในการ์ดเดียว เห็นพร้อมกันหมด ไม่มีอะไรถูกพับซ่อนไว้
   * ช่องที่เป็น select / ชิป กดแล้วค้นหาให้ทันที ส่วนช่องพิมพ์รอกด Enter หรือปุ่มค้นหา
   * ------------------------------------------------------------------------- */
  renderFilters = () => {
    const { filter, channels, categories, zones, admins } = this.state;

    const select = (key, options, onChange) => (
      <Select
        className="prop-field prop-select"
        default={false}
        placeholder={t("all")}
        value={filter[key]}
        options={options}
        onChange={onChange || ((value) => this.setFilter({ [key]: value }))}
      />
    );

    return (
      <div className="prop-card mk-in mb-3">
        <div className="prop-card__head">
          <span className="prop-title text-15">
            <span className="prop-title__dot" />
            {t("search_filters")}
          </span>
          <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm" onClick={this.clearAll}>
            <span className="icon text-12">{""}</span>
            {t("clear_filters")}
          </button>
        </div>

        <div className="p-4">
          <div className="row g-3">
            {/* แถว 1 — ที่ใช้บ่อยที่สุด */}
            <div className="col-xl-4 col-lg-6">
              <label className="prop-label">{t("search")}</label>
              <div className="position-relative">
                <span className="icon prop-field-icon">{""}</span>
                <input
                  type="text"
                  className="prop-field prop-field--icon"
                  placeholder={t("mk_search_placeholder")}
                  value={filter.keyword}
                  onChange={(e) => this.setFilter({ keyword: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
            </div>

            <div className="col-xl-2 col-lg-6 col-md-6">
              <label className="prop-label">{t("status")}</label>
              {select("status", [
                { value: "all", label: t("all_status") },
                ...PROPERTY_STATUS.map((e) => ({ value: e.value, label: t(e.label) })),
              ])}
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6">
              <label className="prop-label">{t("property_type")}</label>
              {select("type", [
                { value: "", label: t("all_property_types") },
                ...categories.map((c) => ({ value: c.code, label: categoryName(c) })),
              ])}
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6">
              <label className="prop-label">{t("deal_type")}</label>
              <div className="prop-seg">
                {DEALS.map((d) => {
                  const on = (filter.deals || []).includes(d.value);
                  return (
                    <button
                      key={d.value}
                      type="button"
                      aria-pressed={on}
                      className={`prop-seg__btn ${on ? "is-active" : ""}`}
                      onClick={() =>
                        this.setFilter({
                          deals: on ? (filter.deals || []).filter((e) => e !== d.value) : [...(filter.deals || []), d.value],
                        })
                      }
                    >
                      {t(d.label)}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* แถว 2 */}
            <div className="col-xl-3 col-lg-6 col-md-6">
              <label className="prop-label">{t("mk_col_channels")}</label>
              {select("channel", [
                { value: "", label: t("mk_all_channels") },
                ...channels.map((c) => ({ value: c.uid, label: channelName(c) })),
              ])}
              {/* โหมดของตัวกรองช่องทาง — ไม่มีความหมายถ้ายังไม่เลือกช่องทาง จึงโผล่มาคู่กันเท่านั้น */}
              {!!filter.channel && (
                <div className="prop-seg mt-2">
                  {[
                    { value: "posted", label: "mk_channel_posted" },
                    { value: "missing", label: "mk_channel_missing" },
                  ].map((mode) => (
                    <button
                      key={mode.value}
                      type="button"
                      aria-pressed={filter.channel_mode === mode.value}
                      className={`prop-seg__btn ${filter.channel_mode === mode.value ? "is-active" : ""}`}
                      onClick={() => this.setFilter({ channel_mode: mode.value })}
                    >
                      {t(mode.label)}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6">
              <label className="prop-label">{t("zone_district")}</label>
              {select("district", [
                { value: "", label: t("all") },
                ...zones.map((z) => ({ value: z.district, label: z.district })),
              ])}
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6">
              <label className="prop-label">{t("mk_col_owner")}</label>
              {select("admin", [{ value: "", label: t("all") }, ...admins.map((a) => ({ value: a.uid, label: a.full_name }))])}
            </div>

            <div className="col-xl-3 col-lg-6 col-md-6">
              <label className="prop-label">{t("rent_per_month_baht")}</label>
              <div className="prop-minmax">
                <input
                  type="text"
                  className="prop-field"
                  placeholder={t("min")}
                  value={filter.rent_min}
                  onChange={(e) => /^\d*$/.test(e.target.value) && this.setFilter({ rent_min: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
                <span className="prop-minmax__sep">-</span>
                <input
                  type="text"
                  className="prop-field"
                  placeholder={t("max")}
                  value={filter.rent_max}
                  onChange={(e) => /^\d*$/.test(e.target.value) && this.setFilter({ rent_max: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
            </div>


            <div className="col-12 d-flex justify-content-end">
              <button type="button" className="prop-btn" onClick={() => this.Get(1)}>
                <span className="icon text-14">{""}</span>
                {t("search")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /** ช่องติ๊กเลือกทรัพย์ — ใช้ทั้งบนหัวตาราง (ทั้งหน้า) และบนแถว */
  renderCheck = (checked, onChange, label, indeterminate = false) => (
    <label className="mk-check" title={label} onClick={(e) => e.stopPropagation()}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        // ติ๊กไปบางส่วนของหน้า = ขีดกลาง ไม่ใช่ติ๊กถูก (ตั้งผ่าน DOM ได้ทางเดียว)
        ref={(el) => el && (el.indeterminate = indeterminate)}
      />
    </label>
  );

  /* ========================================================== render : แถวตาราง */
  renderRow = (item) => {
    const mk = item.marketing || {};
    const status = statusMeta(item.status);
    const picked = !!this.state.selected[item.uid];
    const flash = this.state.flash.includes(item.uid);

    const days = daysSince(mk.last_posted_at);
    const age = ageLevel(days);
    const posted = mk.posted_count || 0;
    const total = mk.channel_total || 0;
    const bar = coverageColor(posted, total);

    /* เฉพาะช่องที่โพสต์ไปแล้ว เรียงจากที่เพิ่งลงล่าสุดไปหาเก่าสุด
       ชิปตัวแรกจึงเป็นช่องเดียวกับที่คอลัมน์ "โพสต์ล่าสุด" ข้าง ๆ พูดถึงเสมอ
       และเวลาโชว์ไม่ครบ (+N) ตัวที่ถูกตัดออกจะเป็นของเก่าสุดซึ่งสำคัญน้อยกว่า */
    const done = (mk.channels || [])
      .filter((c) => c.last_posted_at)
      .sort((a, b) => new Date(b.last_posted_at) - new Date(a.last_posted_at));
    const shown = done.slice(0, CHIP_LIMIT);
    const rest = done.length - shown.length;

    return (
      <tr
        key={item.uid}
        className={`${age.key === "late" ? "is-late" : age.key === "warn" ? "is-warn" : ""} ${picked ? "is-picked" : ""} ${
          flash ? "is-flash" : ""
        }`}
      >
        <td className="mk-c-check">
          {this.renderCheck(picked, () => this.toggleSelect(item), item.code)}
        </td>

        <td className="mk-c-code">
          <span className="mk-code">{item.code}</span>
        </td>

        <td>
          <div className="mk-asset">
            <div className="mk-thumb" style={item.asset_category?.grad ? { background: item.asset_category.grad } : {}}>
              {item.image ? (
                <img src={item.image} alt={item.title} />
              ) : (
                <span className="mk-thumb__ghost icon">{item.asset_category?.icon || ""}</span>
              )}
            </div>
            {/* ชื่อและทำเลยาวเกินให้ตัดเป็น ... — ความกว้างถูกคุมด้วย .mk-asset__text */}
            <div className="mk-asset__text">
              <span className="mk-asset__name text-truncate" onClick={() => this.OpenHistory(item)} title={item.title}>
                {item.title || "-"}
              </span>
              <div className="mk-asset__meta">
                <span className="text-truncate" title={item.district}>{item.district || "-"}</span>
                {/* ป้ายประเภททรัพย์ใช้สีพื้นชุดเดียวกับรูปย่อของประเภทนั้น (grad จากข้อมูล master)
                    กวาดตาลงมาแล้วแยกประเภทออกจากกันได้โดยไม่ต้องอ่านตัวหนังสือ */}
                {!!item.asset_category && (
                  <span className="mk-tag" style={item.asset_category.grad ? { background: item.asset_category.grad } : {}}>
                    {categoryName(item.asset_category)}
                  </span>
                )}
              </div>
            </div>
          </div>
        </td>

        <td className="mk-c-rent">
          <span className="mk-price">{money(item.rent)}</span>
          <span className="mk-price__unit">{t("baht_per_month")}</span>
        </td>

        <td className="mk-c-status">
          <span className="mk-badge" style={{ backgroundColor: status.tint, color: status.color }}>
            {t(status.label)}
          </span>
        </td>

        {/* โพสต์ล่าสุด — สีของเวลาบอกความเร่งด่วนโดยไม่ต้องอ่านตัวเลข */}
        <td className="mk-c-last">
          {mk.last_posted_at ? (
            <>
              <div className="mk-last__time" style={{ color: age.color }}>
                {relativeTime(mk.last_posted_at)}
              </div>
              {!!mk.last_channel_code && (
                <div className="mk-last__sub">
                  {channelName((mk.channels || []).find((c) => c.uid === mk.last_channel_uid)) || mk.last_channel_code}
                </div>
              )}
              {!!mk.last_user && <div className="mk-last__by">{t("mk_by")} {mk.last_user.full_name}</div>}
            </>
          ) : (
            <span className="mk-last__none">
              <span className="icon text-10">{""}</span>
              {t("mk_never")}
            </span>
          )}
        </td>

        {/* ช่องทางการตลาด — โชว์เฉพาะช่องที่โพสต์ไปแล้ว กดชิปเพื่อบันทึกเพิ่มได้เลย
            ช่องที่โพสต์ซ้ำหลายครั้งมีตัวเลขจำนวนครั้งกำกับมุมบนขวาของชิป */}
        <td className="mk-c-chan">
          <div className="mk-chans">
            {/* ชิปเป็นตัวบอกสถานะอย่างเดียว กดไม่ได้ — ปุ่มสั่งงานอยู่คอลัมน์ "จัดการ" ที่เดียว
                จะได้ไม่มีจุดที่กดโดนแล้วเปิดฟอร์มบันทึกโดยไม่ตั้งใจตอนกวาดสายตาดูตาราง */}
            {shown.map((channel) => (
              <span
                key={channel.uid}
                className="mk-chan"
                style={{ "--mk-chan-color": channel.color || "#9ca3af" }}
                title={`${channelName(channel)} · ${relativeTime(channel.last_posted_at)}${
                  channel.post_count > 1 ? ` · ${channel.post_count} ${t("mk_times")}` : ""
                }`}
              >
                {this.glyph(channel)}
                {channel.post_count > 1 && <span className="mk-chan__n">{channel.post_count}</span>}
              </span>
            ))}
            {/* +N เป็นปุ่มเดียวในคอลัมน์นี้ที่กดได้ — เปิดดูช่องทางทั้งหมดของทรัพย์แถวนั้น (ดูอย่างเดียว) */}
            {rest > 0 && (
              <button
                type="button"
                className="mk-chan__more"
                title={t("mk_view_channels")}
                onClick={() => this.OpenChannels(item)}
              >
                +{rest}
              </button>
            )}
            {!done.length && <span className="text-secondary text-12">-</span>}
          </div>
        </td>

        <td className="mk-c-prog text-center">
          <div className="mk-prog">
            <span className="mk-prog__value" style={{ color: bar }}>{posted}</span>
            <span className="mk-prog__total"> / {total}</span>
            <span className="mk-prog__track">
              <span
                className="mk-prog__fill"
                style={{ width: `${total ? (posted / total) * 100 : 0}%`, background: bar }}
              />
            </span>
          </div>
        </td>

        <td className="mk-c-owner">
          {item.admin_name ? (
            <span className="mk-owner">
              <span className="mk-owner__avatar">{initials(item.admin_name)}</span>
              <span className="mk-owner__name" title={item.admin_name}>{item.admin_name}</span>
            </span>
          ) : (
            <span className="text-secondary text-12">-</span>
          )}
        </td>

        <td className="mk-c-act">
          <div className="mk-actions">
            {can("marketing.create") && (
              <button
                type="button"
                // ยังไม่เคยโพสต์ / ค้างเกิน 7 วัน = งานด่วน ปุ่มจึงเปลี่ยนเป็นสีเตือน
                className={`mk-iconbtn ${age.key === "late" ? "mk-iconbtn--urgent" : "mk-iconbtn--post"}`}
                title={t("mk_log_post")}
                onClick={() => this.OpenPost(item)}
              >
                <span className="icon">{""}</span>
              </button>
            )}
            <button
              type="button"
              className="mk-iconbtn"
              title={t("mk_post_history")}
              onClick={() => this.OpenHistory(item)}
            >
              <span className="icon">{""}</span>
            </button>
          </div>
        </td>
      </tr>
    );
  };

  /* ================================================== render : ปุ่มสลับมุมมอง
   * อยู่ที่หัวการ์ดผลลัพธ์ของทั้งสองมุมมอง ตำแหน่งเดียวกันเป๊ะ กดสลับไปมาแล้วปุ่ม
   * ไม่ขยับหนีนิ้ว (การ์ดสรุปและการ์ดกรองด้านบนใช้ร่วมกันอยู่แล้วทั้งคู่)
   * ------------------------------------------------------------------------- */
  renderViewToggle = () => (
    <div className="prop-seg mk-viewseg">
      {VIEWS.map((view) => (
        <button
          key={view.value}
          type="button"
          aria-pressed={this.state.view === view.value}
          className={`prop-seg__btn mk-viewseg__btn ${this.state.view === view.value ? "is-active" : ""}`}
          onClick={() => this.SwitchView(view.value)}
          /* ไอคอนล้วนไม่มีคำกำกับ ชื่อมุมมองจึงต้องอยู่ใน title กับ aria-label แทน
             (title ให้คนที่ชี้ค้างไว้ · aria-label ให้โปรแกรมอ่านหน้าจอ) */
          title={t(view.label)}
          aria-label={t(view.label)}
        >
          <span className="icon">{view.icon}</span>
        </button>
      ))}
    </div>
  );

  /* ==================================================== render : มุมมองปฏิทิน
   * ใช้ภาษาเดียวกับปฏิทินของเมนูนัดหมายทั้งชุด (crm-cal / crm-cell / crm-monthbar)
   * ไม่ได้ก๊อปสไตล์มาไว้ที่นี่ แต่เรียกคลาสเดิมตรง ๆ — ปรับสีปฏิทินที่ crm.css ที่เดียว
   * แล้วทั้งสองเมนูขยับตามกันเสมอ ไม่มีทางเพี้ยนออกจากกันทีหลัง
   *
   * ช่องละ 1 วัน บอก 3 อย่างพอ : ลงไปกี่โพสต์ · ลงช่องทางไหนบ้าง · กระจายกี่ทรัพย์
   * รายละเอียดของจริงอยู่ในรายการที่กางออกมาเมื่อกดเลือกวัน ไม่ยัดลงในช่องเล็ก ๆ
   * ------------------------------------------------------------------------- */
  renderCalendar = () => {
    const { cal_month, cal_days, cal_assets, cal_date, cal_posts, cal_total, channels } = this.state;

    const byDate = new Map(cal_days.map((day) => [day.date, day]));
    const cells = monthCells(cal_month);
    const today = format_date(new Date(), "yyyy-mm-dd", "en");

    const posts = cal_days.reduce((sum, day) => sum + (day.posts || 0), 0);

    // หัวเรื่องเดือน — ปีพุทธศักราชเมื่อใช้ภาษาไทย ตรงกับที่อื่นทั้งระบบ
    const title = format_date(dateOf(`${cal_month}-01`), "mmmm yyyy", isTh() ? "th" : "en");
    const selected = cal_date ? byDate.get(cal_date) : null;

    return (
      <div className="mk-card mk-in">
        <div className="prop-card__head">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <span className="prop-title text-15">
              <span className="prop-title__dot" />
              {t("mk_calendar_title")}
              <span className="text-secondary fw-normal text-12 ms-2">
                {money(posts)} {t("mk_unit_posts")}
              </span>
            </span>
          </div>
          {this.renderViewToggle()}
        </div>

        {/* แถบเลื่อนเดือน — ปุ่ม "เดือนนี้" โผล่เฉพาะตอนที่เลื่อนออกไปแล้ว
            อยู่ที่เดิมตลอดจะกินที่ฟรีทั้งที่กดแล้วไม่เกิดอะไรขึ้น */}
        <div className="mk-calbar">
          <div className="crm-monthbar">
            <button type="button" className="crm-nav icon" title={t("previous")} onClick={() => this.ChangeMonth(-1)}>
              {""}
            </button>
            <span className="crm-month">{title}</span>
            <button type="button" className="crm-nav icon" title={t("next")} onClick={() => this.ChangeMonth(1)}>
              {""}
            </button>
            {cal_month !== monthOf(new Date()) && (
              <button
                type="button"
                className="prop-btn prop-btn--ghost prop-btn--sm"
                onClick={() => this.GetCalendar(monthOf(new Date()))}
              >
                {t("mk_this_month")}
              </button>
            )}
          </div>

          {/* สรุปของเดือน — "มีงานกี่วัน" คือตัวเลขที่บอกความสม่ำเสมอได้ตรงที่สุด
              ส่วนจำนวนทรัพย์ในขอบเขตตัวกรอง เอาไว้เทียบว่ายอดโพสต์เยอะหรือน้อยเมื่อเทียบกับของที่มี */}
          <div className="mk-calsum">
            <span>
              <b>{money(cal_days.length)}</b> {t("mk_cal_active_days")}
            </span>
            <span>
              <b>{money(cal_assets)}</b> {t("mk_cal_in_scope")}
            </span>
          </div>
        </div>

        <div className="mk-calwrap">
          <div className="crm-cal mk-cal">
            <div className="crm-cal__dow">
              {WEEKDAYS.map((key, i) => (
                <span key={key} className={i === 0 || i === 6 ? "is-weekend" : ""}>
                  {t(key)}
                </span>
              ))}
            </div>

            <div className="crm-cal__grid">
              {cells.map((cell) => {
                const day = byDate.get(cell.key);
                const chips = (day?.channels || []).slice(0, CAL_CHIP_LIMIT);
                const rest = (day?.channels || []).length - chips.length;
                const weekend = cell.date.getDay() === 0 || cell.date.getDay() === 6;
                const isToday = cell.key === today;

                /* วันของเดือนข้างเคียงกดไม่ได้ — ยอดรายวันที่โหลดมาครอบเฉพาะเดือนนี้
                   ถ้าปล่อยให้กดได้ วันที่จริง ๆ มีโพสต์จะขึ้นว่า "ไม่มีการโพสต์" ซึ่งผิด
                   ช่องพวกนี้มีไว้บอกขอบเขตเดือนอย่างเดียว (เลื่อนเดือนไปดูได้อยู่แล้ว) */
                return (
                  <div
                    key={cell.key}
                    role={cell.out ? undefined : "button"}
                    tabIndex={cell.out ? undefined : 0}
                    className={`crm-cell ${cell.out ? "is-out" : ""} ${weekend ? "is-weekend" : ""} ${
                      isToday ? "is-today" : ""
                    } ${cell.key === cal_date ? "is-selected" : ""}`}
                    onClick={() => !cell.out && this.PickDay(cell.key)}
                    onKeyDown={(e) => !cell.out && e.key === "Enter" && this.PickDay(cell.key)}
                  >
                    <div className="crm-cell__head">
                      <span className={`crm-cell__no ${isToday ? "is-today" : ""}`}>{cell.date.getDate()}</span>
                      {/* มีหน่วยกำกับ เพราะในช่องเดียวกันมีอีกตัวเลขอยู่มุมล่างซ้าย
                          ตัวเลขลอย ๆ 2 ตัวในช่องเล็ก ๆ แยกไม่ออกว่าอันไหนนับอะไร */}
                      {!!day && (
                        <span className="crm-cell__tally">
                          {money(day.posts)} {t("mk_unit_posts")}
                        </span>
                      )}
                    </div>

                    {!!day && (
                      <>
                        {/* จุดสีช่องทางที่ลงไปวันนั้น ซ้อนเหลื่อมกันเพื่อประหยัดที่
                            ไม่ต้องอ่านออกว่าช่องไหนบ้าง แค่เห็นว่า "วันนี้ลงหลายช่อง" ก็พอ
                            ที่เหลือดูได้จากคำอธิบายสีใต้ปฏิทินและรายการของวันนั้น */}
                        <span className="mk-cal__chips">
                          {chips.map((channel) => (
                            <span
                              key={channel.uid}
                              className="mk-cal__chip"
                              style={{ "--mk-chan-color": channel.color || "#9ca3af" }}
                              title={`${channelName(channel)} · ${money(channel.posts)} ${t("mk_unit_posts")}`}
                            >
                              {this.glyph(channel)}
                            </span>
                          ))}
                          {rest > 0 && <span className="mk-cal__more">+{rest}</span>}
                        </span>

                        {/* "กี่ทรัพย์" ต่างจาก "กี่โพสต์" มุมบนขวา — ทรัพย์เดียวลงหลายช่องทาง
                            นับเป็นทรัพย์เดียว จึงต้องเขียนหน่วยให้ชัดว่าเป็นรายการทรัพย์ */}
                        <span className="mk-cal__assets">
                          {money(day.assets)} {t("mk_unit_assets")}
                        </span>
                      </>
                    )}
                  </div>
                );
              })}
            </div>

            {/* คำอธิบายสีช่องทาง — วางใต้ปฏิทินเหมือนคำอธิบายสถานะของเมนูนัดหมาย
                จุดในช่องวันเล็กเกินกว่าจะอ่านไอคอนออก ต้องมีที่เทียบสีให้ */}
            {!!channels.length && (
              <div className="crm-legend">
                {channels.map((channel) => (
                  <span className="crm-legend__item" key={channel.uid}>
                    <span className="crm-legend__swatch" style={{ backgroundColor: channel.color || "#9ca3af" }} />
                    {channelName(channel)}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ---------------------------------------------- รายการโพสต์ของวันที่เลือก */}
        {cal_date ? (
          <div className="mk-calday">
            <div className="mk-calday__head">
              <span className="mk-calday__title">
                <span className="icon text-12">{""}</span>
                {format_date(dateOf(cal_date), "d mmmm yyyy", isTh() ? "th" : "en")}
              </span>
              <span className="mk-calday__sum">
                {money(cal_total)} {t("mk_unit_posts")}
                {!!selected && ` · ${money(selected.assets)} ${t("mk_unit_assets")}`}
              </span>
              <button type="button" className="mk-tl__act" title={t("close")} onClick={() => this.PickDay(cal_date)}>
                <span className="icon">{""}</span>
              </button>
            </div>

            {cal_posts.length ? (
              <div className="mk-callist">
                {cal_posts.map((post) => (
                  <div className="mk-calrow" key={post.uid}>
                    <span className="mk-tl__time">{format_date(post.posted_at, "hh:mm", "en")}</span>

                    <span className="mk-tl__dot" style={{ "--mk-chan-color": post.channel?.color || "#9ca3af" }}>
                      {post.channel ? this.glyph(post.channel) : <span className="icon">{""}</span>}
                    </span>

                    <div className="mk-calrow__main">
                      {/* กดชื่อทรัพย์แล้วเปิดแผงรายละเอียดตัวเดิมที่ใช้ในตาราง —
                          จากปฏิทินก็เข้าถึงข้อมูลทรัพย์ได้โดยไม่ต้องสลับกลับไปหาในตาราง */}
                      <span className="mk-calrow__asset" onClick={() => post.asset && this.OpenHistory(post.asset)}>
                        <span className="mk-code">{post.asset?.code || "-"}</span>
                        <span className="mk-calrow__title text-truncate">{post.asset?.title || "-"}</span>
                      </span>
                      <div className="mk-calrow__meta">
                        {channelName(post.channel) || "-"}
                        {!!post.page_name && ` · ${post.page_name}`}
                        {!!post.user && ` · ${t("mk_by")} ${post.user.full_name}`}
                      </div>
                    </div>

                    <span className="mk-tl__acts">
                      {!!post.post_url && (
                        <a className="mk-tl__act" href={post.post_url} target="_blank" rel="noreferrer" title={t("mk_open_post")}>
                          <span className="icon">{""}</span>
                        </a>
                      )}
                      {can("marketing.update") && (
                        <button type="button" className="mk-tl__act" title={t("edit")} onClick={() => this.OpenEditPost(post)}>
                          <span className="icon">{""}</span>
                        </button>
                      )}
                      {can("marketing.delete") && (
                        <button
                          type="button"
                          className="mk-tl__act mk-tl__act--del"
                          title={t("delete")}
                          onClick={() => this.DeletePost(post)}
                        >
                          <span className="icon">{""}</span>
                        </button>
                      )}
                    </span>
                  </div>
                ))}

                {/* รายการถูกตัดมาแล้วถ้าวันนั้นยกชุดขึ้นทีเดียวเป็นพันแถว — ต้องบอกให้รู้ */}
                {cal_posts.length < cal_total && (
                  <div className="mk-tl__more">
                    {t("mk_showing")} {cal_posts.length} / {money(cal_total)} {t("mk_unit_posts")}
                  </div>
                )}
              </div>
            ) : (
              <div className="mk-empty">
                <div className="mk-empty__icon icon">{""}</div>
                <div className="fw-bold text-dark mb-1">{t("mk_cal_day_empty")}</div>
              </div>
            )}
          </div>
        ) : (
          !!cal_days.length && (
            <div className="mk-calhint">
              <span className="icon text-12">{""}</span>
              {t("mk_cal_pick_day")}
            </div>
          )
        )}

        {!cal_days.length && (
          <div className="mk-empty">
            <div className="mk-empty__icon icon">{""}</div>
            <div className="fw-bold text-dark mb-1">{t("mk_cal_empty")}</div>
            <div className="text-12">{t("mk_cal_empty_desc")}</div>
          </div>
        )}
      </div>
    );
  };


  /* =========================================================== render : ตาราง */
  renderTable = () => {
    const { data, count, page, sort, selected } = this.state;

    const picked = Object.keys(selected).length;
    const onPage = data.filter((item) => selected[item.uid]).length;

    return (
      <div className="mk-card mk-in">
        {/* หัวตาราง : ชื่อ + จำนวนผลลัพธ์ + ปุ่มของชุดที่ติ๊กไว้ ทางซ้าย · การเรียงลำดับทางขวา
            ปุ่มของชุดที่เลือกอยู่ฝั่งซ้ายเพราะช่องติ๊กอยู่ริมซ้ายของตาราง สายตาไม่ต้องข้ามจอไปกด
            และตัวเรียงลำดับทางขวาจะได้อยู่ที่เดิมตลอด ไม่ขยับตอนปุ่มโผล่/หาย */}
        <div className="prop-card__head">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <span className="prop-title text-15">
              <span className="prop-title__dot" />
              {t("mk_queue_title")}
              <span className="text-secondary fw-normal text-12 ms-2">
                {money(count)} {t("unit_items")}
              </span>
            </span>

            {/* โผล่เฉพาะตอนมีของที่ติ๊กไว้ — ตัวเลขบนปุ่มคือที่เลือกไว้ทั้งหมด
                (รวมที่ติ๊กค้างไว้จากหน้าอื่นด้วย) */}
            {!!picked && (
              <span className="d-flex flex-wrap align-items-center gap-2">
                {can("marketing.create") && (
                  <button type="button" className="prop-btn prop-btn--sm" onClick={this.OpenBulkPost} title={t("mk_bulk_info")}>
                    {/* ไอคอนเขียนด้วย \u — ตัวอักษรจริงอยู่ย่าน PUA ของฟอนต์ FontAwesome ถ้าวางตรง ๆ มักหายระหว่างแก้ไฟล์ */}
                    <span className="icon text-12">{"\uf14a"}</span>
                    {t("mk_bulk_log_post")}
                    <span className="mk-count">{picked}</span>
                  </button>
                )}
                <button
                  type="button"
                  className="prop-btn prop-btn--ghost prop-btn--sm"
                  onClick={this.ClearSelection}
                >
                  {t("clear_selection")}
                </button>
              </span>
            )}
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2">
            <span className="text-secondary text-12">{t("sort_by")}</span>
            <Select
              className="prop-field prop-select wpx-220"
              default={false}
              placeholder={t("sort_by")}
              value={sort}
              options={SORTS.map((s) => ({ value: s.value, label: t(s.label) }))}
              onChange={(value) => value && this.Get(1, this.state.applied, value)}
            />
            {this.renderViewToggle()}
          </div>
        </div>

        {data.length ? (
          <>
            <div className="mk-scroll">
              <table className="mk-table">
                {/* ตารางกว้างเท่าหน้าจอเสมอ (table-layout: fixed) ความกว้างของคอลัมน์
                    กำหนดที่หัวตารางที่เดียว ช่อง "ชื่อทรัพย์" กินที่เหลือทั้งหมด
                    คอลัมน์ที่รองลงมาถูกซ่อนเมื่อจอแคบ แทนที่จะปล่อยให้ต้องเลื่อนแนวนอน */}
                <thead>
                  <tr>
                    <th className="mk-c-check">
                      {this.renderCheck(
                        onPage > 0 && onPage === data.length,
                        this.toggleSelectPage,
                        t("select_page"),
                        onPage > 0 && onPage < data.length
                      )}
                    </th>
                    <th className="mk-c-code">{t("mk_col_code")}</th>
                    <th>{t("mk_col_asset")}</th>
                    <th className="mk-c-rent">{t("rent_price")}</th>
                    <th className="mk-c-status">{t("status")}</th>
                    <th className="mk-c-last">{t("mk_col_last_post")}</th>
                    <th className="mk-c-chan">{t("mk_col_channels")}</th>
                    <th className="mk-c-prog text-center">{t("mk_col_progress")}</th>
                    <th className="mk-c-owner">{t("mk_col_owner")}</th>
                    <th className="mk-c-act text-center">{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>{data.map((item) => this.renderRow(item))}</tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 p-3 text-secondary text-12">
              <div>
                {t("showing")} {(page - 1) * PAGE_SIZE + 1}-{Math.min(page * PAGE_SIZE, count)} {t("of")} {money(count)} {t("unit_items")}
              </div>
              <Pagination
                className="mb-0"
                page={page}
                count={Math.ceil(count / PAGE_SIZE) || 1}
                showFirstButton={false}
                showLastButton={false}
                onChange={(_, next) => {
                  this.Get(next, this.state.applied);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            </div>
          </>
        ) : (
          <div className="mk-empty">
            <div className="mk-empty__icon icon">{""}</div>
            <div className="fw-bold text-dark mb-1">{t("mk_empty_title")}</div>
            <div className="text-12">{t("mk_empty_desc")}</div>
            <button type="button" className="prop-btn prop-btn--ghost prop-btn--sm mt-3" onClick={this.clearAll}>
              <span className="icon text-12">{""}</span>
              {t("clear_all")}
            </button>
          </div>
        )}
      </div>
    );
  };

  /* ================================================ render : โมดัลบันทึกการโพสต์ */
  renderPostModal = () => {
    const { post_open, post_mode, post_item, post_targets, post_channels, post_entries, channels, admins } = this.state;

    // โหมด bulk = ทรัพย์ที่ติ๊กไว้ทั้งชุด · โหมดปกติ = รายการเดียว
    const bulk = post_mode === "bulk";
    const targets = bulk ? post_targets : post_item ? [post_item] : [];
    if (!targets.length) return null;

    /** ช่องทางนี้ทรัพย์ในชุดเคยลงไปแล้วกี่รายการ — ใช้แทน "โพสต์ล่าสุด" ของรายการเดียว */
    const doneCount = (uid) =>
      targets.filter((item) => (item.marketing?.channels || []).some((c) => c.uid === uid && c.last_posted_at)).length;

    /* วันเวลาที่โพสต์ของช่องทางหนึ่ง ๆ — ห้ามเลือกเกินตอนนี้ (ดู setEntryWhen)
       ปฏิทินปิดวันในอนาคตด้วย max และช่องเวลาจำกัดเพดานเมื่อวันที่ที่เลือกคือวันนี้
       เวลาใช้ input type="time" ของเบราว์เซอร์ เพราะเป็นการบันทึกเวลาที่โพสต์ไปแล้วจริง ๆ
       ไม่ใช่การเลือกรอบเวลาตั้งเผยแพร่ที่มีให้เลือกเป็นช่วง ๆ */
    const now = new Date();
    const today = format_date(now, "yyyy-mm-dd", "en");
    const nowTime = format_date(now, "hh:mm", "en");

    const datetime = (entry, uid) => (
      <>
        <div className="col-sm-6">
          <label className="prop-label">{t("mk_posted_at")}</label>
          <DatePicker
            type="th"
            className="prop-field"
            value={entry.at}
            max={now}
            onChange={(value) => this.setEntryWhen(uid, { at: value })}
            key={uid}
          />
        </div>
        <div className="col-sm-6">
          <label className="prop-label">{t("mk_time")}</label>
          <input
            type="time"
            className="prop-field"
            value={entry.time || ""}
            /* ยังไม่เลือกวัน = ถือเป็นวันนี้ เพดานเวลาจึงเป็นตอนนี้เหมือนกัน */
            max={!entry.at || entry.at === today ? nowTime : undefined}
            onChange={(e) => this.setEntryWhen(uid, { time: e.target.value })}
          />
        </div>
        {entry.future && (
          <div className="col-12 mk-warn">
            <span className="icon">{"\uf071"}</span>
            {t("mk_future_not_allowed")}
          </div>
        )}
      </>
    );

    return (
      <Modal show={post_open} onHide={this.ClosePost} size="lg" centered scrollable dialogClassName="mk-dialog">
        <Modal.Header className="mk-modal__head">
          <div>
            <h5 className="mk-modal__title">{bulk ? t("mk_bulk_log_post") : t("mk_log_post")}</h5>
            <div className="mk-modal__sub">
              {bulk ? (
                <>
                  <span className="mk-modal__pill">
                    {targets.length} {t("unit_items")}
                  </span>
                  {/* บอกรหัสไว้พอให้ทวนได้ว่าติ๊กถูกชุด ไม่ต้องไล่ทั้งหมดจนหัวเรื่องยาว */}
                  {targets.slice(0, 3).map((item) => item.code).join(" · ")}
                  {targets.length > 3 ? ` +${targets.length - 3}` : ""}
                </>
              ) : (
                <>
                  <span className="mk-modal__pill">{post_item.code}</span>
                  {post_item.title}
                </>
              )}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="mk-modal__body">
          {/* บอกให้ชัดก่อนกรอกว่าโหมดนี้ทุกรายการได้ข้อมูลชุดเดียวกันหมด
              โดยเฉพาะลิงก์โพสต์ที่ของจริงย่อมคนละลิงก์ต่อทรัพย์ */}
          {bulk && (
            <div className="mk-note mb-3">
              <span className="mk-note__icon icon">{"\uf05a"}</span>
              <div>
                <div className="mk-note__title">{t("mk_bulk_info")}</div>
                <div className="mk-note__sub">{t("mk_bulk_info_url")}</div>
              </div>
            </div>
          )}

          {/* ---------------------------------------------- 1) เลือกช่องทาง
              ไม่ติ๊กอะไรไว้ให้ล่วงหน้า ผู้ใช้เลือกเองว่ารอบนี้ลงช่องไหนไปบ้าง */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
            <label className="prop-label mb-0">{t("mk_select_channels")}</label>
            <div className="d-flex gap-2">
              <button type="button" className="prop-link" onClick={() => this.setAllChannels(true)}>
                {t("select_all")}
              </button>
              <span className="text-secondary">·</span>
              <button type="button" className="prop-link" onClick={() => this.setAllChannels(false)}>
                {t("clear_all")}
              </button>
            </div>
          </div>

          <div className="mk-picks">
            {channels.map((channel) => {
              const on = post_channels.includes(channel.uid);
              const state = (post_item?.marketing?.channels || []).find((c) => c.uid === channel.uid);

              return (
                <button
                  key={channel.uid}
                  type="button"
                  className={`mk-pick ${on ? "is-on" : ""}`}
                  style={{ "--mk-chan-color": channel.color || "#9ca3af" }}
                  onClick={() => this.togglePostChannel(channel.uid)}
                >
                  <span className="mk-pick__icon">
                    {this.glyph(channel)}
                    {!bulk && state?.post_count > 1 && <span className="mk-chan__n">{state.post_count}</span>}
                  </span>
                  <span className="overflow-hidden">
                    <span className="mk-pick__name d-block text-truncate">{channelName(channel)}</span>
                    {/* รายการเดียว : เคยลงช่องนี้ครั้งล่าสุดเมื่อไร กี่ครั้งแล้ว
                        หลายรายการ : ในชุดที่เลือกไว้ มีกี่รายการที่เคยลงช่องนี้ไปแล้ว */}
                    <span className="mk-pick__sub d-block">
                      {bulk
                        ? `${t("mk_bulk_channel_done")} ${doneCount(channel.uid)}/${targets.length}`
                        : state?.last_posted_at
                        ? `${t("mk_last")} ${relativeTime(state.last_posted_at)}${
                            state.post_count > 1 ? ` · ${state.post_count} ${t("mk_times")}` : ""
                          }`
                        : t("mk_never")}
                    </span>
                  </span>
                  <span className="mk-pick__mark icon">{""}</span>
                </button>
              );
            })}
            {!channels.length && <div className="text-secondary text-12 py-3">{t("mk_no_channel")}</div>}
          </div>

          {!!post_channels.length && (
            <>
              {/* ------------------------------------ 2) รายละเอียดของแต่ละช่องทาง
                  เรียงตามลำดับของ master ไม่ใช่ลำดับที่กดเลือก ตำแหน่งจะได้ไม่สลับไปมา */}
              <div className="d-flex align-items-baseline flex-wrap gap-2 mt-4 mb-2">
                <label className="prop-label mb-0">{t("mk_post_details")}</label>
                <span className="text-secondary text-10">{t("mk_posted_at_hint")}</span>
              </div>
              <div className="d-flex flex-column gap-3">
                {channels
                  .filter((channel) => post_channels.includes(channel.uid))
                  .map((channel) => {
                    const entry = post_entries[channel.uid] || {};

                    return (
                      <div className="mk-entry" key={channel.uid}>
                        <div className="mk-entry__head">
                          <span className="mk-chan" style={{ "--mk-chan-color": channel.color || "#9ca3af" }}>
                            {this.glyph(channel)}
                          </span>
                          <span className="mk-entry__name text-truncate">{channelName(channel)}</span>
                          <button
                            type="button"
                            className="mk-entry__x icon"
                            title={t("mk_remove_channel")}
                            onClick={() => this.togglePostChannel(channel.uid)}
                          >
                            {""}
                          </button>
                        </div>

                        <div className="row g-3">
                          {/* วันเวลาที่โพสต์ของช่องทางนี้ — ทุกช่องระบุของตัวเองเสมอ */}
                          {datetime(entry, channel.uid)}

                          <div className="col-md-6">
                            <label className="prop-label">{t("mk_page_name")}</label>
                            <input
                              type="text"
                              className="prop-field"
                              placeholder={t("mk_page_name_placeholder")}
                              value={entry.page_name || ""}
                              onChange={(e) => this.setEntry(channel.uid, { page_name: e.target.value })}
                            />
                          </div>

                          <div className="col-md-6">
                            <label className="prop-label">{t("mk_posted_by")}</label>
                            <Select
                              className="prop-field prop-select"
                              default={false}
                              placeholder={t("mk_posted_by")}
                              value={entry.user || ""}
                              options={admins.map((a) => ({ value: a.uid, label: a.full_name }))}
                              onChange={(value) => this.setEntry(channel.uid, { user: value })}
                            />
                          </div>

                          <div className="col-12">
                            <label className="prop-label">{t("mk_post_url")}</label>
                            <input
                              type="text"
                              className="prop-field"
                              placeholder={t("mk_post_url_placeholder")}
                              value={entry.post_url || ""}
                              onChange={(e) => this.setEntry(channel.uid, { post_url: e.target.value })}
                            />
                          </div>

                          <div className="col-12">
                            <label className="prop-label">{t("mk_post_note")}</label>
                            <textarea
                              className="prop-field mk-textarea"
                              rows={2}
                              placeholder={t("mk_post_note_placeholder")}
                              value={entry.note || ""}
                              onChange={(e) => this.setEntry(channel.uid, { note: e.target.value })}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          {/* โหมดชุด : บอกจำนวนแถวที่กำลังจะถูกเขียนจริง ๆ (รายการ × ช่องทาง) ไม่ใช่แค่จำนวนช่องทาง */}
          <div className="text-secondary text-12 me-auto">
            {t("selected_count")} {post_channels.length} {t("mk_channel_selected")}
            {bulk && ` × ${targets.length} ${t("unit_items")} = ${money(post_channels.length * targets.length)} ${t("mk_unit_posts")}`}
          </div>
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.ClosePost}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SavePost}>
            <span className="icon text-14">{""}</span>
            {t("mk_save_post")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };



  /* ========================================= render : โมดัลดูช่องทางทั้งหมด
   * เปิดจากปุ่ม +N ในตาราง — ดูอย่างเดียว ไม่มีอะไรให้กดนอกจากปิด
   * โชว์ครบทุกช่องทางที่เปิดใช้งาน ช่องที่ยังไม่ได้ลงจะจางลง จะได้เห็นทั้ง
   * "ลงอะไรไปแล้ว" และ "ยังขาดอะไร" ในภาพเดียว
   * ------------------------------------------------------------------------- */
  renderChannelsModal = () => {
    const { chan_open, chan_item } = this.state;
    if (!chan_item) return null;

    const mk = chan_item.marketing || {};

    // ลงแล้วขึ้นก่อน เรียงจากล่าสุดไปเก่าสุด (ลำดับเดียวกับชิปในตาราง) ที่ยังไม่ได้ลงต่อท้าย
    const list = [...(mk.channels || [])].sort((a, b) => {
      if (!!a.last_posted_at !== !!b.last_posted_at) return a.last_posted_at ? -1 : 1;
      if (!a.last_posted_at) return 0;
      return new Date(b.last_posted_at) - new Date(a.last_posted_at);
    });

    return (
      <Modal show={chan_open} onHide={this.CloseChannels} centered scrollable dialogClassName="mk-dialog">
        <Modal.Header className="mk-modal__head">
          <div>
            <h5 className="mk-modal__title">{t("mk_col_channels")}</h5>
            <div className="mk-modal__sub">
              <span className="mk-modal__pill">{chan_item.code}</span>
              {mk.posted_count || 0} / {mk.channel_total || 0} {t("mk_channel_selected")}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="mk-modal__body">
          <div className="mk-chlist">
            {list.map((channel) => {
              const on = !!channel.last_posted_at;

              return (
                <div className={`mk-chrow ${on ? "" : "is-off"}`} key={channel.uid}>
                  <span
                    className={`mk-chan ${on ? "" : "is-off"}`}
                    style={{ "--mk-chan-color": channel.color || "#9ca3af" }}
                  >
                    {this.glyph(channel)}
                    {channel.post_count > 1 && <span className="mk-chan__n">{channel.post_count}</span>}
                  </span>
                  <span className="overflow-hidden">
                    <span className="mk-chrow__name">{channelName(channel)}</span>
                    <span className="mk-chrow__sub">
                      {on
                        ? `${t("mk_last")} ${relativeTime(channel.last_posted_at)}${
                            channel.post_count > 1 ? ` · ${channel.post_count} ${t("mk_times")}` : ""
                          }`
                        : t("mk_never")}
                    </span>
                  </span>
                </div>
              );
            })}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseChannels}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  /* ============================================ ดาวน์โหลดไฟล์ทั้งชุดในการ์ดเดียว
   * ขอเป็น zip ก้อนเดียวจาก API แล้วเซฟทีเดียว ไม่ใช่ไล่เซฟทีละไฟล์
   *   - ไฟล์จริงอยู่บน R2 คนละโดเมนกับหน้าเว็บ จะรวม zip เองที่ฝั่งนี้ก็ต้องดึงข้ามโดเมนอยู่ดี
   *   - เบราว์เซอร์มองการเซฟรัว ๆ หลายไฟล์ว่าเป็น automatic download แล้วบล็อก
   *     ตั้งแต่ไฟล์ที่สองเป็นต้นไป (เงียบ ๆ ด้วย) — คลิกเดียวได้ไฟล์เดียวจึงชัวร์กว่า
   *   - ชื่อไฟล์ใน zip ถูกตั้งเป็น <รหัสทรัพย์>-01.jpg มาจากฝั่ง API แล้ว
   *
   * ระหว่างรอปุ่มจะกดซ้ำไม่ได้ ไฟล์ชุดใหญ่ใช้เวลาหลายวินาที ถ้ากดซ้ำได้จะได้ zip ซ้อนกันหลายก้อน
   * ------------------------------------------------------------------------- */
  DownloadFiles = async (type, count) => {
    const asset = this.state.history_asset;
    if (this.state.downloading || !asset || !count) return;

    this.setState({ downloading: type });
    const result = await GET_FILE(`admin/assets/${asset.uid}/files/download`, { type });
    this.setState({ downloading: "" });

    if (!result?.status || !result.blob) {
      return alert("", "warning", t("warning"), result?.message || t("mk_download_failed"));
    }

    saveAs(result.blob, `${asset.code || "asset"}${type === "photos" ? "" : `-${type}`}.zip`);
    alert("", "success", t("success"), `${t("mk_download_done")} ${count} ${t("unit_items")}`);
  };

  /* คัดลอกรายละเอียดประกาศทั้งก้อน — ภาษาที่กำลังเปิดอยู่ ไม่ใช่ทุกภาษารวมกัน
     คนกดคือคนที่เลือกภาษาไว้เองเพื่อเอาไปวางในช่องทางที่กำลังจะโพสต์

     ตอบด้วยการเปลี่ยนปุ่มเป็นข้อความ "คัดลอกแล้ว" สีเขียว 2 วินาที ไม่เด้ง popup
     เพราะการคัดลอกเป็นงานที่ทำซ้ำ ๆ ทีละภาษา — popup ที่ต้องปิดทุกครั้งขวางทางมากกว่าช่วย */
  CopyDescription = (text) => {
    if (!text) return;

    navigator.clipboard?.writeText(text);
    clearTimeout(this.copiedTimer);
    this.setState({ copied: true });
    this.copiedTimer = setTimeout(() => this.setState({ copied: false }), 2000);
  };

  /* ========================================= render : ชิ้นส่วนของแผงรายละเอียด
   * ใช้ร่วมกันทุกแท็บ จะได้หน้าตาเหมือนกันหมดโดยไม่ต้องเขียนโครงเดิมซ้ำทุกการ์ด
   * ------------------------------------------------------------------------- */

  /** การ์ด 1 บล็อกในแผง — หัวการ์ดมีไอคอนนำสายตา และมีที่ว่างขวามือไว้ใส่ของเสริม */
  dcard = (icon, title, body, extra) => (
    <section className="mk-dcard mt-3">
      <div className="mk-dcard__head">
        <span className="mk-dcard__title">
          <span className="mk-dcard__icon icon">{icon}</span>
          {title}
        </span>
        {extra}
      </div>
      <div className="mk-dcard__body">{body}</div>
    </section>
  );

  /** ปุ่มเล็กมุมขวาของหัวการ์ด — ใช้กับงานที่ทำกับ "ของทั้งการ์ด" เช่น คัดลอก / ดาวน์โหลด
      วางไว้ในหัวการ์ดเพราะขอบเขตของปุ่มคือการ์ดใบนั้น ไม่ใช่ทั้งแท็บ */
  dact = (icon, label, onClick, disabled) => (
    <button type="button" className="mk-dact" onClick={onClick} disabled={disabled}>
      <span className="mk-dact__icon icon">{icon}</span>
      {label}
    </button>
  );

  /** แถว label : value — ช่องที่ไม่มีข้อมูลไม่แสดงเลย ดีกว่าโชว์ "-" เต็มไปหมด */
  dline = (label, value) =>
    value === null || value === undefined || value === "" || value === 0 ? null : (
      <div className="mk-dline" key={label}>
        <span className="mk-dline__label">{label}</span>
        <span className="mk-dline__value">{value}</span>
      </div>
    );

  dempty = (icon, text) => (
    <div className="mk-dnone">
      <span className="icon">{icon}</span>
      {text}
    </div>
  );

  dchips = (items, modifier = "") => (
    <div className="mk-dtags">
      {items.map((item, i) => (
        <span key={i} className={`mk-dtag ${modifier}`}>
          {item}
        </span>
      ))}
    </div>
  );

  /* ============================================ render : แท็บ "ข้อมูลทรัพย์"
   * ข้อมูลชุดเดียวกับที่กรอกไว้ในขั้นตอนที่ 1 และ 3 ของหน้าเพิ่ม-แก้ไขทรัพย์
   * เรียงจาก "ตัวเลขที่ต้องใช้ตอนคุยกับลูกค้า" ลงไปหารายละเอียดปลีกย่อย
   * ------------------------------------------------------------------------- */
  renderTabInfo = () => {
    const d = this.state.history_asset;
    if (!d) return this.dempty("", t("mk_no_asset_detail"));

    // ที่ดินคิดขนาดเป็นตารางวา ประเภทอื่นเป็นพื้นที่ใช้สอยตารางเมตร
    const land = !d.area && !!d.land_area;
    const size = land ? d.land_area : d.area;

    const keys = [];
    if ((d.deals || []).includes("rent")) {
      keys.push({ icon: "", label: t("rent_price"), value: money(d.rent), unit: t("baht_per_month"), accent: true });
    }
    if ((d.deals || []).includes("sale")) {
      keys.push({ icon: "", label: t("sale_price"), value: money(d.price), unit: t("unit_baht"), accent: true });
    }
    if (size) keys.push({ icon: "", label: land ? t("land_area") : t("area_size"), value: decimal(size), unit: land ? t("sqw") : t("sqm") });
    if (d.bedroom) keys.push({ icon: "", label: t("bedrooms"), value: d.bedroom, unit: t("bed_unit") });
    if (d.bathroom) keys.push({ icon: "", label: t("bathrooms"), value: d.bathroom, unit: t("bath_unit") });
    // ที่จอดรถไม่ใช่ตัวเลขแล้ว จึงย้ายลงไปอยู่ในตาราง "ข้อมูลจำเพาะ" ด้านล่างแทนแถบตัวเลข

    const specs = [
      this.dline(t("property_type"), categoryName(d.asset_category)),
      this.dline(t("project"), d.project),
      this.dline(t("floor_label"), d.floor ? `${d.floor}${d.building ? ` · ${t("building_label")} ${d.building}` : ""}` : ""),
      this.dline(t("parking"), parkingTypes(d).map((e) => t(e.label)).join(" · ")),
      this.dline(t("direction"), d.direction ? t(directionMeta(d.direction)?.label || "") : ""),
      this.dline(t("built_year"), d.built_year),
      // ที่ดินโชว์ขนาดที่ดินไปแล้วในแถบตัวเลขด้านบน ตรงนี้จึงโชว์เฉพาะกรณีมีทั้งสองค่า
      this.dline(t("land_area"), !land && d.land_area ? `${decimal(d.land_area)} ${t("sqw")}` : ""),
      this.dline(t("available_date"), d.available_at ? dateTH(d.available_at) : ""),
      this.dline(t("price_per_sqm"), d.price && d.area ? `${money(d.price / d.area)} ${t("unit_baht")}` : ""),
    ].filter(Boolean);

    const place = [
      this.dline(t("address_label"), d.address),
      this.dline(t("soi"), d.soi),
      this.dline(t("subdistrict"), d.subdistrict),
      this.dline(t("zone_district"), d.district),
      this.dline(t("province"), d.province),
      this.dline(t("postcode"), d.postcode),
    ].filter(Boolean);

    const finance = [
      // ระยะสัญญาเช่า — 0 หรือไม่ระบุ = ไม่กำหนดขั้นต่ำ ไม่ต้องขึ้นบรรทัด
      this.dline(t("contract_term"), d.contract_term ? `${d.contract_term} ${t(contractUnitMeta(d.contract_unit).label)}` : ""),
      this.dline(t("deposit"), d.deposit ? `${money(d.deposit)} ${t("unit_baht")}` : ""),
      this.dline(t("advance_payment"), d.advance_month ? `${d.advance_month} ${t("unit_months")}` : ""),
      this.dline(t("move_in_payment"), d.move_in_payment ? `${money(d.move_in_payment)} ${t("unit_baht")}` : ""),
      this.dline(t("water_fee"), d.water_fee ? `${money(d.water_fee)} ${t("unit_baht")}` : ""),
      this.dline(t("common_fee"), d.common_fee_month ? `${money(d.common_fee_month)} ${t("unit_baht")}` : ""),
    ].filter(Boolean);

    const langs = DESC_LANGS.filter((e) => (d[e.field] || "").trim());
    const lang = langs.find((e) => e.value === this.state.history_lang) || langs[0];

    return (
      <>
        {!!keys.length && (
          <div className="mk-dkeys">
            {keys.map((e, i) => (
              <div key={i} className={`mk-dkey ${e.accent ? "is-accent" : ""}`}>
                <div className="mk-dkey__label">
                  <span className="icon">{e.icon}</span>
                  {e.label}
                </div>
                <div className="mk-dkey__value">
                  {e.value}
                  <span className="mk-dkey__unit">{e.unit}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {!!specs.length && this.dcard("", t("spec_detail"), specs)}

        {this.dcard(
          "",
          t("location"),
          <>
            {place.length ? place : this.dempty("", t("no_data"))}
            {!!(d.latitude && d.longitude) && (
              <a
                className="prop-btn prop-btn--ghost prop-btn--sm w-100 mt-3"
                href={`https://www.google.com/maps/search/?api=1&query=${d.latitude},${d.longitude}`}
                target="_blank"
                rel="noreferrer"
              >
                <span className="icon text-12">{""}</span>
                {t("open_google_maps")}
              </a>
            )}
          </>
        )}

        {!!finance.length && this.dcard("", t("finance_info"), finance)}

        {this.dcard(
          "",
          t("amenities"),
          (d.amenities || []).length || d.amenity_other
            ? this.dchips([
                ...(d.amenities || []).map((value) => {
                  const item = amenityMeta(value);
                  return (
                    <>
                      {!!item?.icon && <span className="icon me-1">{item.icon}</span>}
                      {item ? t(item.label) : value}
                    </>
                  );
                }),
                ...(d.amenity_other ? [d.amenity_other] : []),
              ])
            : this.dempty("", t("no_amenity"))
        )}

        {(!!(d.tags || []).length || !!(d.keywords || []).length) &&
          this.dcard(
            "",
            t("highlights_tags"),
            <>
              {!!(d.tags || []).length &&
                this.dchips(
                  (d.tags || []).map((value) => (tagMeta(value) ? t(tagMeta(value).label) : value)),
                  "is-soft"
                )}
              {!!(d.keywords || []).length && (
                <>
                  <div className="mk-dline__label mt-3 mb-2">{t("keyword_th")}</div>
                  {this.dchips(d.keywords)}
                </>
              )}
            </>
          )}

        {!!(d.nearby || []).length &&
          this.dcard(
            "",
            t("nearby_places"),
            (d.nearby || []).map((item, i) => {
              const type = nearbyMeta(item.type);
              return (
                <div className="mk-dnear" key={i}>
                  <span className="mk-dnear__icon icon">{type.icon}</span>
                  <span className="mk-dnear__name text-truncate">
                    {item.label}
                    <span className="mk-dnear__type">{t(type.label)}</span>
                  </span>
                  {!!item.distance && <span className="mk-dnear__dist">{decimal(item.distance)} {t("unit_km_short")}</span>}
                </div>
              );
            })
          )}

        {this.dcard(
          "",
          t("description"),
          lang ? <div className="mk-dtext">{d[lang.field]}</div> : this.dempty("", t("no_description_yet")),
          <div className="mk-dcard__tools">
            {langs.length > 1 && (
              <div className="mk-dseg">
                {langs.map((e) => (
                  <button
                    key={e.value}
                    type="button"
                    className={`mk-dseg__btn ${lang?.value === e.value ? "is-active" : ""}`}
                    onClick={() => this.setState({ history_lang: e.value })}
                  >
                    {t(e.label)}
                  </button>
                ))}
              </div>
            )}
            {!!lang &&
              (this.state.copied ? (
                <span className="mk-dcopied">
                  <span className="icon">{"\uf00c"}</span>
                  {t("mk_description_copied")}
                </span>
              ) : (
                this.dact("\uf0c5", t("copy"), () => this.CopyDescription(d[lang.field]))
              ))}
          </div>
        )}
      </>
    );
  };

  /* ================================================ render : แท็บ "รูปภาพ"
   * ชุดสื่อทั้งหมดของทรัพย์ (ขั้นตอนที่ 2 ของหน้าเพิ่ม-แก้ไขทรัพย์)
   * รูปใหญ่ 1 รูป + แถวรูปย่อให้กด เพราะแผงกว้างไม่พอจะกางเป็นตารางแล้วยังเห็นรายละเอียด
   * ------------------------------------------------------------------------- */
  renderTabPhoto = () => {
    const d = this.state.history_asset;
    if (!d) return this.dempty("", t("mk_no_asset_detail"));

    const photos = d.photos || [];
    const plans = d.floor_plans || [];
    const index = photos.length ? Math.min(this.state.history_photo, photos.length - 1) : 0;
    const dl = this.state.downloading;

    return (
      <>
        {this.dcard(
          "",
          t("photos"),
          photos.length ? (
            <>
              <div className="mk-dgal">
                <img src={photos[index].file_path} alt={`${d.title} ${index + 1}`} />
                {photos.length > 1 && (
                  <>
                    <button
                      type="button"
                      className="mk-dgal__nav mk-dgal__nav--prev icon"
                      aria-label={t("previous")}
                      onClick={() => this.setState({ history_photo: (index - 1 + photos.length) % photos.length })}
                    >
                      {""}
                    </button>
                    <button
                      type="button"
                      className="mk-dgal__nav mk-dgal__nav--next icon"
                      aria-label={t("next")}
                      onClick={() => this.setState({ history_photo: (index + 1) % photos.length })}
                    >
                      {""}
                    </button>
                  </>
                )}
                <span className="mk-dgal__index">
                  {index + 1} / {photos.length}
                </span>
              </div>

              {photos.length > 1 && (
                <div className="mk-dthumbs">
                  {photos.map((photo, i) => (
                    <button
                      key={photo.uid || i}
                      type="button"
                      className={`mk-dthumb ${i === index ? "is-active" : ""}`}
                      onClick={() => this.setState({ history_photo: i })}
                    >
                      <img src={photo.file_path} alt={`${d.title} ${i + 1}`} />
                    </button>
                  ))}
                </div>
              )}
            </>
          ) : (
            this.dempty("", t("no_photo_yet"))
          ),
          <div className="mk-dcard__tools">
            <span className="mk-dcard__count">
              {photos.length} {t("unit_items")}
            </span>
            {!!photos.length &&
              this.dact(
                "\uf019",
                dl === "photos" ? t("mk_downloading") : t("mk_download_all"),
                () => this.DownloadFiles("photos", photos.length),
                !!dl
              )}
          </div>
        )}

        {!!plans.length &&
          this.dcard(
            "",
            t("floor_plan"),
            <div className="mk-dplans">
              {plans.map((plan, i) => (
                <a key={plan.uid || i} className="mk-dplan" href={plan.file_path} target="_blank" rel="noreferrer">
                  <img src={plan.file_path} alt={`${t("floor_plan")} ${i + 1}`} />
                </a>
              ))}
            </div>,
            <div className="mk-dcard__tools">
              <span className="mk-dcard__count">
                {plans.length} {t("unit_items")}
              </span>
              {this.dact(
                "\uf019",
                dl === "floor_plans" ? t("mk_downloading") : t("mk_download_all"),
                () => this.DownloadFiles("floor_plans", plans.length),
                !!dl
              )}
            </div>
          )}

        {!!d.video_url &&
          this.dcard(
            "",
            t("video_or_link"),
            <a className="mk-dfile" href={d.video_url} target="_blank" rel="noreferrer">
              <span className="mk-dfile__icon icon">{""}</span>
              <span className="mk-dfile__name text-truncate">{d.video_url}</span>
              <span className="mk-dfile__go icon">{""}</span>
            </a>
          )}
      </>
    );
  };

  /* =========================================== render : แท็บ "ข้อมูลเจ้าของ"
   * เจ้าของทรัพย์ที่ต้องติดต่อจริง และคู่สัญญาที่ปิดดีลไปแล้ว
   * (ชุดเดียวกับขั้นตอน "ข้อมูลภายใน" ของหน้าเพิ่ม-แก้ไขทรัพย์) ไม่ออกหน้าเว็บลูกค้า
   * เบอร์และอีเมลกดโทร/กดส่งได้ทันที เพราะแผงนี้มักถูกเปิดตอนกำลังจะติดต่อพอดี
   *
   * ตั้งใจไม่มีนายหน้าร่วม (Co-Agent) และผู้ดูแล/สถิติของประกาศในแท็บนี้ —
   * คนละเรื่องกับ "เจ้าของทรัพย์คือใคร ติดต่อยังไง" ซึ่งเป็นคำถามเดียวที่แท็บนี้ตอบ
   * ------------------------------------------------------------------------- */
  renderTabOwner = () => {
    const d = this.state.history_asset;
    if (!d) return this.dempty("", t("mk_no_asset_detail"));

    const contact = (icon, label, value, href) =>
      !value ? null : (
        <div className="mk-dcontact" key={label}>
          <span className="mk-dcontact__icon icon">{icon}</span>
          <span className="mk-dcontact__text">
            <span className="mk-dcontact__label">{label}</span>
            {href ? (
              <a className="mk-dcontact__value" href={href}>
                {value}
              </a>
            ) : (
              <span className="mk-dcontact__value">{value}</span>
            )}
          </span>
        </div>
      );

    const owner = [
      contact("", t("owner_name"), d.owner_name),
      contact("", t("owner_phone"), d.owner_phone, `tel:${d.owner_phone}`),
      contact("", t("owner_line"), d.owner_line),
      contact("", t("owner_facebook"), d.owner_facebook),
      contact("", t("owner_email"), d.owner_email, `mailto:${d.owner_email}`),
    ].filter(Boolean);

    const deal = [
      this.dline(t("customer_name"), d.customer_name),
      this.dline(t("deal_code"), d.deal_code),
      this.dline(t("deal_value"), d.deal_value ? `${money(d.deal_value)} ${t("unit_baht")}` : ""),
      this.dline(t("commission"), d.commission ? `${money(d.commission)} ${t("unit_baht")}` : ""),
      this.dline(t("mk_reserved_date"), d.reserved_at ? dateTH(d.reserved_at) : ""),
      this.dline(t("mk_closed_date"), d.closed_at ? dateTH(d.closed_at) : ""),
    ].filter(Boolean);

    return (
      <>
        {this.dcard(
          "",
          t("mk_owner_contact"),
          <>
            {owner.length ? owner : this.dempty("", t("no_data"))}
            {!!d.owner_overseas && (
              <div className="mt-2">{this.dchips([t("owner_overseas")])}</div>
            )}
          </>,
          <span className="mk-dlock">
            <span className="icon text-10">{""}</span>
            {t("internal_only")}
          </span>
        )}

        {!!deal.length && this.dcard("", t("mk_deal_info"), deal)}
      </>
    );
  };

  /* ================================================== render : แท็บ "โน้ต" */
  renderTabNote = () => {
    const d = this.state.history_asset;
    if (!d) return this.dempty("", t("mk_no_asset_detail"));

    return (
      <>
        {this.dcard(
          "",
          t("internal_note"),
          d.internal_note ? <div className="mk-dtext">{d.internal_note}</div> : this.dempty("", t("mk_no_note")),
          <span className="mk-dlock">
            <span className="icon text-10">{""}</span>
            {t("internal_only")}
          </span>
        )}

        {this.dcard(
          "",
          t("documents"),
          (d.documents || []).length ? (
            d.documents.map((doc, i) => (
              <a key={doc.uid || i} className="mk-dfile" href={doc.file_path} target="_blank" rel="noreferrer">
                <span className="mk-dfile__icon icon">{""}</span>
                <span className="mk-dfile__name text-truncate">{doc.file_name || t("open_file")}</span>
                <span className="mk-dfile__go icon">{""}</span>
              </a>
            ))
          ) : (
            this.dempty("", t("no_data"))
          ),
          <span className="mk-dcard__count">
            {(d.documents || []).length} {t("unit_items")}
          </span>
        )}
      </>
    );
  };

  /* ============================================== render : แท็บ "การตลาด"
   * แท็บตั้งต้นของแผง — ตอบงานที่กำลังทำอยู่ก่อน
   *   1) ความคืบหน้า — ลงไปแล้วกี่ช่องจากทั้งหมด ช่องไหนบ้าง ยังขาดช่องไหน
   *   2) ปุ่มหลัก    — บันทึกการโพสต์รอบใหม่
   *   3) ไทม์ไลน์    — 5 รายการล่าสุด ที่เหลือกางต่อได้ จัดกลุ่มตามวัน กรองรายช่องทางได้
   * ------------------------------------------------------------------------- */
  renderTabMarketing = () => {
    const { history_item, history_posts, history_total, history_channel, history_all } = this.state;

    const mk = history_item.marketing || {};
    const posted = mk.posted_count || 0;
    const total = mk.channel_total || 0;
    const bar = coverageColor(posted, total);
    const pct = total ? Math.round((posted / total) * 100) : 0;
    const age = ageLevel(daysSince(mk.last_posted_at));

    /* ตัวเลือกตัวกรอง = เฉพาะช่องทางที่มีอยู่จริงในประวัติชุดนี้
       ใส่ช่องที่ยังไม่เคยลงเข้ามาด้วยจะได้เมนูที่เลือกแล้วว่างเปล่าทุกอัน */
    const used = [];
    history_posts.forEach((post) => {
      if (post.channel && !used.some((c) => c.uid === post.channel.uid)) used.push(post.channel);
    });

    const list = history_channel ? history_posts.filter((post) => post.channel?.uid === history_channel) : history_posts;
    // เปิดมาโชว์แค่ 5 รายการล่าสุด ที่เหลืออยู่หลังปุ่ม "ดูประวัติทั้งหมด"
    const groups = groupByDay(history_all ? list : list.slice(0, HISTORY_PREVIEW));

    return (
      <>
        {/* ------------------------------------------------- ความคืบหน้าช่องทาง
            การ์ดใบเดียวตอบครบว่า ลงไปกี่ช่องแล้ว · คิดเป็นกี่เปอร์เซ็นต์ ·
            ช่องไหนลงแล้ว (สีแบรนด์) ช่องไหนยังขาด (จางลง) */}
        <section className="mk-dcard">
          <div className="mk-dcard__head">
            <span className="mk-dcard__title">
              <span className="mk-dcard__icon icon">{""}</span>
              {t("mk_coverage_title")}
            </span>
            <span className="mk-dcard__pct" style={{ color: bar }}>
              {pct}%
            </span>
          </div>

          <div className="mk-dcard__count mk-dcard__count--big">
            <b style={{ color: bar }}>{posted}</b> / {total} {t("mk_channel_selected")}
          </div>

          <span className="mk-dcard__track">
            <span className="mk-dcard__fill" style={{ width: `${pct}%`, background: bar }} />
          </span>

          <div className="mk-dchips">
            {(mk.channels || []).map((channel) => {
              const on = !!channel.last_posted_at;

              return (
                <span
                  key={channel.uid}
                  className={`mk-dchip ${on ? "" : "is-off"}`}
                  style={{ "--mk-chan-color": channel.color || "#9ca3af" }}
                  title={`${channelName(channel)} · ${
                    on
                      ? `${t("mk_last")} ${relativeTime(channel.last_posted_at)}${
                          channel.post_count > 1 ? ` · ${channel.post_count} ${t("mk_times")}` : ""
                        }`
                      : t("mk_never")
                  }`}
                >
                  <span className="mk-dchip__icon">
                    {this.glyph(channel)}
                    {channel.post_count > 1 && <span className="mk-chan__n">{channel.post_count}</span>}
                  </span>
                  <span className="mk-dchip__name text-truncate">{channelName(channel)}</span>
                </span>
              );
            })}
            {!(mk.channels || []).length && <div className="text-secondary text-12">{t("mk_no_channel")}</div>}
          </div>
        </section>

        {/* --------------------------------------------------------- ปุ่มหลัก
            งานที่คนเปิดแผงนี้มักทำต่อทันทีคือบันทึกโพสต์รอบใหม่ จึงเป็นปุ่มเดียว
            ที่ใช้สีเต็มในแผง และวางไว้ก่อนไทม์ไลน์ที่ยาวจนต้องเลื่อน */}
        <button
          type="button"
          className="prop-btn mk-dcta"
          onClick={() => {
            // ปิดแผงก่อนเปิดฟอร์ม — ซ้อนกัน 2 ชั้นแล้วอ่านยาก และประวัติในแผงจะเป็นภาพเก่าทันทีที่บันทึกเสร็จ
            this.CloseHistory();
            this.OpenPost(history_item);
          }}
        >
          <span className="icon text-14">{""}</span>
          {t("mk_log_post")}
        </button>

        {/* ------------------------------------------------- สรุปตัวเลขประกอบ */}
        <div className="mk-dstats">
          <div className="mk-dstat">
            <div className="mk-dstat__label">{t("mk_col_last_post")}</div>
            <div className="mk-dstat__value" style={{ color: mk.last_posted_at ? age.color : "" }}>
              {mk.last_posted_at ? relativeTime(mk.last_posted_at) : t("mk_never")}
            </div>
          </div>
          <div className="mk-dstat">
            <div className="mk-dstat__label">{t("mk_total_posts")}</div>
            <div className="mk-dstat__value">
              {money(history_total)}
              <span className="mk-dstat__unit">{t("mk_unit_posts")}</span>
            </div>
          </div>
          <div className="mk-dstat">
            <div className="mk-dstat__label">{t("mk_col_owner")}</div>
            <div className="mk-dstat__value text-truncate" title={history_item.admin_name}>
              {history_item.admin_name || "-"}
            </div>
          </div>
        </div>

        {/* --------------------------------------------------------- ไทม์ไลน์
            หัวข้อ + ตัวกรองช่องทางอยู่บรรทัดเดียวกัน แล้วไล่รายการลงมาเป็นกลุ่มตามวัน
            ตัวกรองโผล่เฉพาะตอนที่ประวัติมีมากกว่า 1 ช่องทาง — มีช่องเดียวก็ไม่มีอะไรให้กรอง */}
        <section className="mk-dcard mk-dhist">
          <div className="mk-dhist__head">
            <span className="mk-dcard__title">
              <span className="mk-dcard__icon icon">{""}</span>
              {t("mk_post_history")}
            </span>
            {used.length > 1 && (
              <Select
                className="prop-field prop-select mk-dfilter"
                default={false}
                placeholder={t("mk_all_channels")}
                value={history_channel}
                options={[
                  { value: "", label: t("mk_all_channels") },
                  ...used.map((channel) => ({ value: channel.uid, label: channelName(channel) })),
                ]}
                onChange={(value) => this.setState({ history_channel: value, history_all: false })}
              />
            )}
          </div>

          {groups.length ? (
            <>
              {groups.map((group) => (
                <div className="mk-tl__day" key={group.key}>
                  <div className="mk-tl__date">
                    <span className="mk-tl__date-text">{format_date(group.at, "d mmm yyyy", isTh() ? "th" : "en")}</span>
                    <span className="mk-tl__date-line" />
                    <span className="mk-tl__date-count">
                      {group.posts.length} {t("mk_unit_posts")}
                    </span>
                  </div>

                  <div className="mk-tl">
                    {group.posts.map((post) => (
                      <div className="mk-tl__row" key={post.uid}>
                        {/* จุดบนเส้นเวลา — เป็นตัวลากสายตาลงมาตามลำดับเวลาของวันนั้น
                            แยกออกจากไอคอนช่องทางที่อยู่ถัดไป เพราะคนละเรื่องกัน
                            (จุดนี้บอก "เมื่อไร" ส่วนไอคอนบอก "ลงที่ไหน") */}
                        <span className="mk-tl__bullet" />
                        {/* วันอยู่บนหัวกลุ่มแล้ว แถวจึงเหลือแค่เวลา */}
                        <span className="mk-tl__time">{format_date(post.posted_at, "hh:mm", "en")}</span>

                        <span className="mk-tl__dot" style={{ "--mk-chan-color": post.channel?.color || "#9ca3af" }}>
                          {post.channel ? this.glyph(post.channel) : <span className="icon">{""}</span>}
                        </span>

                        <div className="mk-tl__main">
                          <div className="mk-tl__name text-truncate">{channelName(post.channel) || "-"}</div>
                          {/* ชื่อกลุ่ม/เพจปลายทาง — ช่องทางเดียวลงได้หลายที่ ต้องแยกออกจากกันให้เห็น */}
                          {!!post.page_name && <div className="mk-tl__page text-truncate">{post.page_name}</div>}
                        </div>

                        <div className="mk-tl__side">
                          <span className="mk-tl__by text-truncate">
                            {post.user ? `${t("mk_by")} ${post.user.full_name}` : "-"}
                          </span>
                          <span className="mk-tl__acts">
                            {can("marketing.update") && (
                              <button
                                type="button"
                                className="mk-tl__act"
                                title={t("edit")}
                                onClick={() => this.OpenEditPost(post)}
                              >
                                <span className="icon">{""}</span>
                              </button>
                            )}
                            {can("marketing.delete") && (
                              <button
                                type="button"
                                className="mk-tl__act mk-tl__act--del"
                                title={t("delete")}
                                onClick={() => this.DeletePost(post)}
                              >
                                <span className="icon">{""}</span>
                              </button>
                            )}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* ปุ่มกาง/ย่อ — โผล่เฉพาะตอนที่มีของซ่อนอยู่จริง
                  ประวัติที่ API ส่งมาถูกตัดมาแล้ว ตอนกางหมดจึงต้องบอกด้วยว่าที่เห็นคือกี่จาก
                  ทั้งหมดเท่าไร ไม่งั้นจะเข้าใจว่าโพสต์เก่าหายไป */}
              {list.length > HISTORY_PREVIEW && (
                <button
                  type="button"
                  className="mk-tl__toggle"
                  onClick={() => this.setState({ history_all: !history_all })}
                >
                  <span className="icon text-10">{history_all ? "" : ""}</span>
                  {history_all ? t("mk_collapse_history") : `${t("mk_view_all_history")} (${money(list.length)})`}
                </button>
              )}

              {history_all && !history_channel && history_posts.length < history_total && (
                <div className="mk-tl__more">
                  {t("mk_showing")} {history_posts.length} / {money(history_total)} {t("mk_unit_posts")}
                </div>
              )}
            </>
          ) : (
            <div className="mk-empty">
              <div className="mk-empty__icon icon">{""}</div>
              <div className="fw-bold text-dark mb-1">
                {history_channel ? t("mk_no_history_channel") : t("mk_no_history")}
              </div>
              <div className="text-12">{history_channel ? t("mk_no_history_channel_desc") : t("mk_no_history_desc")}</div>
            </div>
          )}
        </section>
      </>
    );
  };

  /* ======================================= render : แผงรายละเอียดทรัพย์ (สไลด์ขวา)
   * เปิดจากปุ่มประวัติในตาราง หรือกดที่ชื่อทรัพย์ — สไลด์เข้ามาชิดขอบขวาเต็มความสูง
   * เลือกเป็นแผงข้างแทนโมดัลกลางจอ เพราะงานตรงนี้คือ "ส่องดูรายละเอียดของแถวหนึ่ง"
   * แล้วปิดกลับไปทำแถวถัดไป ตารางเบื้องหลังจึงควรยังอยู่ในสายตา ไม่ถูกบังทั้งจอ
   *
   * หัวแผง (รูป · รหัส · สถานะ · ทำเล · ค่าเช่า) กับแถบแท็บตรึงอยู่กับที่เสมอ
   * เลื่อนเฉพาะเนื้อในแท็บ จะได้ไม่หลุดว่ากำลังดูทรัพย์ตัวไหนอยู่
   * ------------------------------------------------------------------------- */
  renderHistoryDrawer = () => {
    const { history_open, history_item, history_tab } = this.state;
    if (!history_item) return null;

    const status = statusMeta(history_item.status);

    return (
      <Modal
        show={history_open}
        onHide={this.CloseHistory}
        scrollable
        /* แผงนี้เป็นหน้าจอ "ดูอย่างเดียว" ไม่มีฟอร์มค้างให้เสียของ จึงปลดล็อกให้กดนอกแผง
           หรือกด Esc ปิดได้ตามที่คนใช้แผงข้างคาดหวัง (ต่างจากโมดัลกรอกฟอร์มที่ตั้ง static ไว้) */
        backdrop
        keyboard
        className="mk-drawer-modal"
        dialogClassName="mk-drawer"
      >
        {/* ---------------------------------------------------------- หัวแผง */}
        <Modal.Header className="mk-drawer__head">
          <div className="mk-drawer__asset">
            <div
              className="mk-drawer__thumb"
              style={history_item.asset_category?.grad ? { background: history_item.asset_category.grad } : {}}
            >
              {history_item.image ? (
                <img src={history_item.image} alt={history_item.title} />
              ) : (
                <span className="icon">{history_item.asset_category?.icon || ""}</span>
              )}
            </div>

            <div className="mk-drawer__text">
              <div className="mk-drawer__tags">
                <span className="mk-modal__pill">{history_item.code}</span>
                <span className="mk-badge" style={{ backgroundColor: status.tint, color: status.color }}>
                  {t(status.label)}
                </span>
              </div>

              <h5 className="mk-drawer__title" title={history_item.title}>
                {history_item.title || "-"}
              </h5>

              <div className="mk-drawer__meta">
                <span className="text-truncate">{history_item.district || "-"}</span>
                {!!history_item.asset_category && <span>{categoryName(history_item.asset_category)}</span>}
              </div>

              {/* ค่าเช่าเป็นตัวเลขเดียวที่ต้องอ่านออกจากหัวแผงแบบไม่ต้องเพ่ง จึงใช้สีแบรนด์ */}
              <div className="mk-drawer__rent">
                {money(history_item.rent)}
                <span className="mk-drawer__rent-unit">{t("baht_per_month")}</span>
              </div>
            </div>
          </div>

          {/* แถบแท็บ — เลื่อนแนวนอนได้บนจอแคบ ไม่ตัดชื่อแท็บทิ้งและไม่ยอมให้ขึ้นบรรทัดที่สอง */}
          <div className="mk-dtabs">
            {DRAWER_TABS.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`mk-dtab ${history_tab === tab.key ? "is-active" : ""}`}
                onClick={() => this.setState({ history_tab: tab.key })}
              >
                <span className="icon text-11">{tab.icon}</span>
                {t(tab.label)}
              </button>
            ))}
          </div>
        </Modal.Header>

        <Modal.Body className="mk-drawer__body">
          {history_tab === "info" && this.renderTabInfo()}
          {history_tab === "photo" && this.renderTabPhoto()}
          {history_tab === "owner" && this.renderTabOwner()}
          {history_tab === "note" && this.renderTabNote()}
          {history_tab === "marketing" && this.renderTabMarketing()}
        </Modal.Body>

        <Modal.Footer className="mk-drawer__foot">
          <button type="button" className="prop-btn prop-btn--ghost w-100" onClick={this.CloseHistory}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  /* ==================================== render : โมดัลแก้บันทึกการโพสต์
   * ฟอร์มเดี่ยวที่เปิดมาพร้อมค่าเดิมครบทุกช่อง แก้แล้วเขียนทับทั้งใบ
   * ซ้อนอยู่บนแผงประวัติ (ไม่ปิดแผง) เพราะแก้เสร็จแล้วต้องเห็นผลในไทม์ไลน์ทันที
   * ------------------------------------------------------------------------- */
  renderEditPostModal = () => {
    const { edit_open, edit_post, edit_form, edit_channel, channels, admins } = this.state;
    if (!edit_post) return null;

    /* ช่องทางที่ถูกปิดใช้งานไปแล้วไม่อยู่ในรายการ master ที่หน้านี้โหลดไว้ ต้องเติมกลับเข้ามา
       ไม่งั้นช่องจะโชว์ว่าง ๆ ทั้งที่บันทึกนี้มีช่องทางอยู่ (ฝั่ง API ยอมให้คงช่องเดิมไว้ได้) */
    const options = channels.some((channel) => channel.uid === edit_channel)
      ? channels
      : [...channels, ...(edit_post.channel ? [edit_post.channel] : [])];

    return (
      <Modal show={edit_open} onHide={this.CloseEditPost} centered scrollable dialogClassName="mk-dialog">
        <Modal.Header className="mk-modal__head">
          <div>
            <h5 className="mk-modal__title">{t("mk_edit_post")}</h5>
            <div className="mk-modal__sub">
              <span className="mk-modal__pill">{format_date(edit_post.posted_at, "dd/mm/yyyy hh:mm", "th")}</span>
              {channelName(edit_post.channel) || "-"}
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="mk-modal__body">
          <div className="row g-3">
            {/* ย้ายช่องทางได้ — บันทึกผิดช่องคือความผิดพลาดที่เจอบ่อยที่สุด
                เดิมต้องลบทิ้งแล้วบันทึกใหม่ทั้งที่ข้อมูลอื่นถูกหมด */}
            <div className="col-12">
              <label className="prop-label">{t("mk_col_channels")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("mk_col_channels")}
                value={edit_channel}
                options={options.map((channel) => ({ value: channel.uid, label: channelName(channel) }))}
                onChange={(value) => this.setState({ edit_channel: value })}
              />
            </div>

            <div className="col-md-7">
              <label className="prop-label">{t("mk_posted_at")}</label>
              <DatePicker
                type="th"
                className="prop-field"
                value={edit_form.at}
                max={new Date()}
                onChange={(value) => this.setEditForm({ at: value })}
              />
            </div>

            <div className="col-md-5">
              <label className="prop-label">{t("mk_time")}</label>
              <input
                type="time"
                className="prop-field"
                value={edit_form.time || ""}
                onChange={(e) => this.setEditForm({ time: e.target.value })}
              />
            </div>

            {/* ขึ้นตอนถูกดึงกลับมาเป็นเวลาปัจจุบันเพราะเลือกอนาคต ไม่ใช่ความผิดพลาดที่ต้องแก้ */}
            {!!edit_form.future && (
              <div className="col-12">
                <div className="mk-warn">
                  <span className="icon">{""}</span>
                  {t("mk_future_not_allowed")}
                </div>
              </div>
            )}

            <div className="col-md-6">
              <label className="prop-label">{t("mk_page_name")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("mk_page_name_placeholder")}
                value={edit_form.page_name || ""}
                onChange={(e) => this.setEditForm({ page_name: e.target.value })}
              />
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("mk_posted_by")}</label>
              <Select
                className="prop-field prop-select"
                default={false}
                placeholder={t("mk_posted_by")}
                value={edit_form.user || ""}
                options={[{ value: "", label: "-" }, ...admins.map((a) => ({ value: a.uid, label: a.full_name }))]}
                onChange={(value) => this.setEditForm({ user: value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("mk_post_url")}</label>
              <input
                type="text"
                className="prop-field"
                placeholder={t("mk_post_url_placeholder")}
                value={edit_form.post_url || ""}
                onChange={(e) => this.setEditForm({ post_url: e.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("mk_post_note")}</label>
              <textarea
                className="prop-field mk-textarea"
                rows={2}
                placeholder={t("mk_post_note_placeholder")}
                value={edit_form.note || ""}
                onChange={(e) => this.setEditForm({ note: e.target.value })}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseEditPost}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveEditPost}>
            <span className="icon text-14">{""}</span>
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    return (
      <div className="w-100 min-vh-100 mk-page">
        <NavbarAdmin />
        <div className="body p-4">
          {/* หัวข้อหน้า */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 mk-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("marketing_board")}</h3>
              <div className="text-secondary text-14">{t("marketing_board_desc")}</div>
            </div>
          </div>

          {this.renderPostModal()}
          {this.renderHistoryDrawer()}
          {/* ซ้อนอยู่บนแผงประวัติ — แก้เสร็จแล้วต้องเห็นผลในไทม์ไลน์ทันทีโดยไม่ต้องเปิดแผงใหม่ */}
          {this.renderEditPostModal()}
          {this.renderChannelsModal()}

          {this.renderKpis()}
          {this.renderFilters()}
          {/* การ์ดสรุปและการ์ดกรองใช้ร่วมกันทั้งสองมุมมอง เปลี่ยนเฉพาะการ์ดผลลัพธ์ใบล่างสุด */}
          {this.state.view === "calendar" ? this.renderCalendar() : this.renderTable()}
        </div>
      </div>
    );
  }
}

export default withRouter(Marketing);
